// // ============================================================
// // src/components/admin/PatientsTab.js
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext"; // ✅ NEW

// const SERVICES_LIST = [
//   "General Checkup & Cleaning",
//   "Cosmetic Dentistry / Smile Makeover",
//   "Dental Implants",
//   "Orthodontics / Invisalign",
//   "Root Canal Therapy",
//   "Pediatric Dentistry",
//   "Oral Surgery",
//   "Periodontal Treatment",
//   "Teeth Whitening",
//   "Emergency Dental Care",
//   "Follow-Up Visit",
//   "Other",
// ];

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const { hospital } = useHospital(); // ✅ NEW — get hospital config
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {}
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       // ✅ Use dynamic hospital name + phone in WhatsApp message
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*${hospital.name}* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 ${hospital.phone}`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ". Appointment added to Upcoming.",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added to Upcoming Appointments.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => {
//               setSelectedPatient(null);
//             }}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {SERVICES_LIST.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           {/* ── Prescription Table ─────────────────────────── */}
//           <style>{`
//             @media (max-width: 640px) {
//               .rx-table-desktop { display: none !important; }
//               .rx-card-mobile { display: block !important; }
//             }
//             @media (min-width: 641px) {
//               .rx-table-desktop { display: block !important; }
//               .rx-card-mobile { display: none !important; }
//             }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* ── DESKTOP TABLE ── */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                           title="Remove"
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* ── MOBILE CARDS ── */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                       title="Remove"
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           {/* ── Doctor Notes / Diagnosis ── */}
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           // ✅ Dynamic hospital name in WhatsApp welcome message
//                           const msg = encodeURIComponent(
//                             ` *Welcome to ${hospital.name}!*\n\n` +
//                               `Dear ${p.name},\n\n` +
//                               `We warmly welcome you to our family. It is a pleasure to have you with us.\n\n` +
//                               `We are committed to providing you the best dental care and a comfortable experience throughout your journey with us.\n\n` +
//                               `_Wishing you great health and a beautiful smile!_\n` +
//                               `— *${hospital.name} Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           hospital={hospital}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database ─────────────────────────────────────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
// ];

// // function saveCustomMed(name, apiPost) {
// //   if (!name || name.trim().length < 3) return Promise.resolve(null);
// //   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
// //   const nameLow = name.trim().toLowerCase();
// //   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
// //   if (already) return Promise.resolve(null);
// //   return apiPost("/custommeds", { name: name.trim(), cat: "Custom" })
// //     .then((saved) => saved || null)
// //     .catch(() => null);
// // }

// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 2) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   // ✅ Use api directly instead of passed apiPost to avoid context loss
//   return fetch(
//     (process.env.REACT_APP_API_URL || "http://localhost:5000/api") +
//       "/custommeds",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         ...(localStorage.getItem("pearlsmile_token")
//           ? {
//               Authorization:
//                 "Bearer " + localStorage.getItem("pearlsmile_token"),
//             }
//           : {}),
//       },
//       body: JSON.stringify({ name: name.trim(), cat: "Custom" }),
//     },
//   )
//     .then((r) => (r.ok ? r.json() : null))
//     .catch((err) => {
//       console.warn("Custom med save failed:", err);
//       return null;
//     });
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase();
//       const catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null);
//   const wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });

//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   const calcPos = () => {
//     if (!inpRef.current) return;
//     const r = inpRef.current.getBoundingClientRect();
//     const spaceBelow = window.innerHeight - r.bottom;
//     const dropH = Math.min(220, sugs.length * 36);
//     const top =
//       spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//     setDropPos({ top, left: r.left, width: r.width });
//   };

//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, matches.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hide();
//     }
//   };

//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0) calcPos();
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hideSuggestions();
//     }
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     const newVal = before + name + after;
//     onChange(newVal);
//     hideSuggestions();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//         hideSuggestions();
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
//         .med-suggestion-item:last-child{border-bottom:none;}
//         .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
//         .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
//         .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
//         .med-sug-name b{color:#0d7377;font-weight:700;}
//         .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal ────────────────────────────────────────
// // ✅ Now accepts hospital prop for dynamic PDF details
// function PrescriptionModal({
//   visit,
//   patient,
//   doctor,
//   hospital,
//   onClose,
//   showNotify,
// }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   // ✅ All hospital values dynamic
//   const hospitalName = hospital?.name || "PearlSmile Dental Hospital";
//   const hospitalAddress = hospital?.address || "12, Dental Plaza, MG Road";
//   const hospitalCity = hospital?.city || "Pune - 411001";
//   const hospitalPhone = hospital?.phone || "+91 87936 08083";
//   const hospitalEmail = hospital?.email || "care@pearlsmiledental.in";
//   const hospitalTagline = hospital?.tagline || "Dental Hospital";
//   // ✅ Stamp bottom text = first 2 words of hospital name
//   const stampText = hospitalName.toUpperCase().split(" ").slice(0, 2).join(" ");
//   // ✅ Header right side = first word + tagline
//   const headerLine1 = hospitalName.toUpperCase().split(" ")[0];
//   const headerLine2 =
//     hospitalName.toUpperCase().split(" ").slice(1).join(" ") ||
//     hospitalTagline.toUpperCase();

//   useEffect(() => {
//     generatePDF();
//   }, []);

//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };

//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;

//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);

//     const NAVY = [8, 25, 65];
//     const BLUE = [20, 80, 160];
//     const LBLUE = [210, 228, 248];
//     const LBLUE2 = [232, 242, 252];
//     const MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130];
//     const TEAL2 = [210, 240, 240];
//     const WHITE = [255, 255, 255];
//     const LGRAY = [245, 247, 251];
//     const LGRAY2 = [250, 251, 254];
//     const LGRAY3 = [240, 243, 248];
//     const GRAY = [115, 118, 130];
//     const GRAY2 = [75, 80, 95];
//     const GOLD = [170, 130, 40];
//     const GOLD2 = [250, 245, 225];
//     const INK = [28, 52, 140];
//     const INK2 = [45, 75, 170];

//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);

//     const visitDate = visit.visitDate || "";
//     const visitTime = visit.visitTime || "";
//     const notes = visit.notes || "";
//     const nextDate = visit.nextVisitDate || "";
//     const service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate);
//     const visitTimeFmt = fmtTimeLocal(visitTime);
//     const nextDateFmt = fmtDateLocal(nextDate);

//     // ── Outer border ──────────────────────────────────────────
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");

//     // ── Header ────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");

//     // Left: doctor name
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);

//     // ✅ Right: dynamic hospital name
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(headerLine1, W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(headerLine2, W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     // ✅ Dynamic address + city
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, 33.5, {
//       align: "right",
//     });
//     // ✅ Dynamic phone + email
//     pdf.text(hospitalPhone + "  |  " + hospitalEmail, W - 10, 38.5, {
//       align: "right",
//     });

//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });

//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });

//     // ── Patient info table ────────────────────────────────────
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }

//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );

//     // ── Prescription Table in PDF ─────────────────────────────
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }

//     // ── Clinical Notes ────────────────────────────────────────
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });

//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);

//     let tableEndY = notesTop + notesBoxH + 8;

//     // ── Next appointment box ──────────────────────────────────
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }

//     // ── General advice box ────────────────────────────────────
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );

//     // ── Watermark — ✅ dynamic hospital name ──────────────────
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text(headerLine1, W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();

//     // ── Doctor seal ───────────────────────────────────────────
//     const sigY = Math.max(advY + 28, H - 55);
//     const cx = W - 46,
//       cy = sigY + 13,
//       R = 18;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");

//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);

//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3);
//     const topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta);
//       const ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }

//     // ✅ Dynamic stamp bottom text
//     pdf.setFontSize(5.5);
//     const botStr = stampText;
//     const botSpan = Math.min(botStr.length * 0.175, 1.4);
//     const botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba);
//       const by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }

//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");
//     pdf.setLineWidth(0.6);
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//       ],
//       cx - 3,
//       cy - 3,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );

//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });

//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });

//     // ── Footer — ✅ fully dynamic ─────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text(hospitalName, 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(hospitalPhone, 10, H - 9.5);
//     pdf.text(hospitalEmail, W / 2, H - 9.5, { align: "center" });
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from " +
//         hospitalName +
//         ". Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );

//     // ── Output ────────────────────────────────────────────────
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";

//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;

//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     ) {
//       setCanNativeShare(true);
//     }
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const nativeShare = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — " + hospitalName,
//           text: "Dear Patient, please find your digital prescription attached.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError") {
//             if (rxMobile) {
//               const waMsg = encodeURIComponent(
//                 "Dear Patient, your digital prescription has been generated. Please find the PDF file attached.",
//               );
//               window.open(
//                 "https://wa.me/" + rxMobile + "?text=" + waMsg,
//                 "_blank",
//               );
//             }
//           }
//         });
//     } else {
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription has been downloaded. Please check the PDF in your Downloads folder.",
//         );
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             ),
//           600,
//         );
//         showNotify(
//           "PDF Downloaded + WhatsApp Opened! ✓",
//           "Prescription saved. WhatsApp opened to patient number.",
//         );
//       } else {
//         showNotify("PDF Downloaded ✓", "Prescription saved. Share manually.");
//       }
//     }
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//             >
//               🔍 Open Full PDF
//             </button>
//             {canNativeShare && (
//               <button
//                 onClick={nativeShare}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "#e5e0d8")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "#f0eeeb")
//                 }
//                 style={{
//                   flex: 1,
//                   background: "#f0eeeb",
//                   color: "#0a1628",
//                   border: "1.5px solid #ddd9d3",
//                   borderRadius: 10,
//                   padding: 10,
//                   fontSize: 13,
//                   fontWeight: 500,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   transition: "background 0.2s",
//                 }}
//               >
//                 📤 Share (Device)
//               </button>
//             )}
//           </div>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Share (Device)" to send directly via WhatsApp.
//             <br />
//             On desktop: use "Open Full PDF" to view, then share manually.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

//////////////// below is orginal content remember ///////////////
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ✅ Services loaded dynamically from hospital's saved services
// // ✅ PDF send — NO auto download, only WhatsApp/Share
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext";

// // ✅ Fallback services by specialty
// const DEFAULT_SERVICES_BY_TYPE = {
//   dental: [
//     "General Checkup & Cleaning",
//     "Cosmetic Dentistry / Smile Makeover",
//     "Dental Implants",
//     "Orthodontics / Invisalign",
//     "Root Canal Therapy",
//     "Pediatric Dentistry",
//     "Oral Surgery",
//     "Periodontal Treatment",
//     "Teeth Whitening",
//     "Emergency Dental Care",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ayurved: [
//     "Panchakarma Detox",
//     "Shirodhara Therapy",
//     "Abhyanga Full Body Massage",
//     "Nasya Treatment",
//     "Kati Basti Back Pain Relief",
//     "Skin & Beauty Treatments",
//     "Herbal Consultation",
//     "Rasayana Therapy",
//     "Yoga & Pranayama",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ortho: [
//     "Joint Replacement Surgery",
//     "Sports Injury Treatment",
//     "Knee Replacement",
//     "Spine Surgery",
//     "Physiotherapy & Rehabilitation",
//     "Arthritis Management",
//     "Fracture Treatment",
//     "Arthroscopy",
//     "Post-Op Rehabilitation",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   eye: [
//     "LASIK Laser Eye Surgery",
//     "Cataract Surgery",
//     "Glaucoma Treatment",
//     "Retina Treatment",
//     "Squint Correction",
//     "Pediatric Ophthalmology",
//     "Eye Checkup",
//     "Contact Lens Fitting",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   cardiology: [
//     "Coronary Angiography",
//     "Angioplasty & Stenting",
//     "Open Heart Surgery CABG",
//     "Pacemaker Implantation",
//     "Preventive Cardiology",
//     "Pediatric Cardiology",
//     "ECG & Stress Test",
//     "Echocardiography",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   pediatric: [
//     "Newborn & Neonatal Care",
//     "Vaccination & Immunization",
//     "Growth & Development Monitoring",
//     "Child Nutrition Counseling",
//     "Pediatric Respiratory Care",
//     "24/7 Pediatric Emergency",
//     "Well Baby Checkup",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   general: [
//     "General Medicine & OPD",
//     "Pathology & Diagnostics",
//     "Emergency & Trauma Care",
//     "Orthopedics & Joint Care",
//     "Cardiology & Heart Care",
//     "Gynecology & Maternity Care",
//     "ENT Treatment",
//     "Dermatology",
//     "Follow-Up Visit",
//     "Other",
//   ],
// };

// // ✅ Get hospitalId from any saved token
// function getHospitalIdFromAnyToken() {
//   try {
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         const token = localStorage.getItem(key);
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//   } catch (_) {}
//   return null;
// }

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const { hospital } = useHospital();
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [servicesList, setServicesList] = useState([]); // ✅ dynamic
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   // ✅ Load services dynamically from this hospital's saved services
//   useEffect(() => {
//     const type = (hospital?.type || "dental").toLowerCase();
//     const hospitalId = getHospitalIdFromAnyToken();
//     const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
//     api
//       .get(url)
//       .then((data) => {
//         if (Array.isArray(data) && data.length > 0) {
//           const names = data.map((s) => s.name);
//           if (!names.includes("Follow-Up Visit")) names.push("Follow-Up Visit");
//           if (!names.includes("Other")) names.push("Other");
//           setServicesList(names);
//         } else {
//           setServicesList(
//             DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//           );
//         }
//       })
//       .catch(() =>
//         setServicesList(
//           DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//         ),
//       );
//   }, [hospital?.type]);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {}
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*${hospital.name}* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 ${hospital.phone}`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ".",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ──────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ────────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => setSelectedPatient(null)}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {/* ✅ Dynamic services from this hospital */}
//                 {servicesList.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           {/* Prescription Table */}
//           <style>{`
//             @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
//             @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* DESKTOP TABLE */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* MOBILE CARDS */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to ${hospital.name}!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family.\n\n_Wishing you great health!_\n— *${hospital.name} Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           hospital={hospital}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database ─────────────────────────────────────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
// ];

// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 2) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   return fetch(
//     (process.env.REACT_APP_API_URL || "http://localhost:5000/api") +
//       "/custommeds",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         ...(localStorage.getItem("pearlsmile_token")
//           ? {
//               Authorization:
//                 "Bearer " + localStorage.getItem("pearlsmile_token"),
//             }
//           : {}),
//       },
//       body: JSON.stringify({ name: name.trim(), cat: "Custom" }),
//     },
//   )
//     .then((r) => (r.ok ? r.json() : null))
//     .catch((err) => {
//       console.warn("Custom med save failed:", err);
//       return null;
//     });
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase(),
//         catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null),
//     wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });
//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };
//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, matches.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };
//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") hide();
//   };
//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0) {
//         if (!inpRef.current) return;
//         const r = inpRef.current.getBoundingClientRect();
//         const spaceBelow = window.innerHeight - r.bottom;
//         const dropH = Math.min(220, sugs.length * 36);
//         const top =
//           spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//         setDropPos({ top, left: r.left, width: r.width });
//       }
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);
//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null),
//     wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0),
//     queryEndRef = React.useRef(0);
//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };
//   const handleChange = (e) => {
//     const ta = e.target,
//       val = ta.value,
//       cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };
//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };
//   const selectMed = (name) => {
//     const ta = taRef.current,
//       val = ta.value;
//     const before = val.substring(0, queryStartRef.current),
//       after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     taRef.current.value.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);
//   return (
//     <>
//       <style>{`.med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}.med-suggestion-item:last-child{border-bottom:none;}.med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}.med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}.med-sug-name{font-weight:500;flex:1;color:#1a1614;}.med-sug-name b{color:#0d7377;font-weight:700;}.med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}`}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal ─────────────────────────────────────────
// // ✅ NO auto-download — only WhatsApp share or manual open
// function PrescriptionModal({
//   visit,
//   patient,
//   doctor,
//   hospital,
//   onClose,
//   showNotify,
// }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   const hospitalName = hospital?.name || "PearlSmile Dental Hospital";
//   const hospitalAddress = hospital?.address || "12, Dental Plaza, MG Road";
//   const hospitalCity = hospital?.city || "Pune - 411001";
//   const hospitalPhone = hospital?.phone || "+91 87936 08083";
//   const hospitalEmail = hospital?.email || "care@pearlsmiledental.in";
//   const hospitalTagline = hospital?.tagline || "Dental Hospital";
//   const stampText = hospitalName.toUpperCase().split(" ").slice(0, 2).join(" ");
//   const headerLine1 = hospitalName.toUpperCase().split(" ")[0];
//   const headerLine2 =
//     hospitalName.toUpperCase().split(" ").slice(1).join(" ") ||
//     hospitalTagline.toUpperCase();

//   useEffect(() => {
//     generatePDF();
//   }, []);
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };
//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;
//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240],
//       WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254];
//     const LGRAY3 = [240, 243, 248],
//       GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95],
//       GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);
//     const visitDate = visit.visitDate || "",
//       visitTime = visit.visitTime || "",
//       notes = visit.notes || "",
//       nextDate = visit.nextVisitDate || "",
//       service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate),
//       visitTimeFmt = fmtTimeLocal(visitTime),
//       nextDateFmt = fmtDateLocal(nextDate);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Health Care", 14, 38.5);
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(headerLine1, W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(headerLine2, W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text(hospitalPhone + "  |  " + hospitalEmail, W - 10, 38.5, {
//       align: "right",
//     });
//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }
//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);
//     let tableEndY = notesTop + notesBoxH + 8;
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text(headerLine1, W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();
//     const sigY = Math.max(advY + 28, H - 55),
//       cx = W - 46,
//       cy = sigY + 13,
//       R = 18;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");
//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);
//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3),
//       topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }
//     pdf.setFontSize(5.5);
//     const botStr = stampText,
//       botSpan = Math.min(botStr.length * 0.175, 1.4),
//       botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }
//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");
//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text(hospitalName, 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(hospitalPhone, 10, H - 9.5);
//     pdf.text(hospitalEmail, W / 2, H - 9.5, { align: "center" });
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from " +
//         hospitalName +
//         ". Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";
//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;
//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     )
//       setCanNativeShare(true);
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   // ✅ NO auto-download — only WhatsApp share
//   const shareViaWhatsApp = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });

//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       // Mobile — native share sheet (WhatsApp visible)
//       navigator
//         .share({
//           title: "Digital Prescription — " + hospitalName,
//           text: "Dear Patient, please find your digital prescription.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError" && rxMobile) {
//             const waMsg = encodeURIComponent(
//               "Dear Patient, your digital prescription is ready. Please contact us to receive the PDF.",
//             );
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             );
//           }
//         });
//     } else {
//       // Desktop — open WhatsApp with message (no auto-download)
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription is ready. Please use the 'Open Full PDF' button to view and download it.",
//         );
//         window.open("https://wa.me/" + rxMobile + "?text=" + waMsg, "_blank");
//         showNotify(
//           "WhatsApp Opened! ✓",
//           "Send the message to notify the patient.",
//         );
//       } else {
//         showNotify(
//           "No mobile number",
//           "Please add patient's mobile number first.",
//           true,
//         );
//       }
//     }
//   };

//   const downloadPDF = () => {
//     if (!pdfBlob) return;
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     showNotify(
//       "Downloaded ✓",
//       "Prescription PDF saved to your Downloads folder.",
//     );
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             {/* ✅ Open Full PDF button */}
//             <button
//               onClick={openFullPreview}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               🔍 Open Full PDF
//             </button>
//             {/* ✅ Download button — only when explicitly clicked */}
//             <button
//               onClick={downloadPDF}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               ⬇️ Download PDF
//             </button>
//           </div>
//           {/* ✅ WhatsApp share — NO auto-download */}
//           <button
//             onClick={shareViaWhatsApp}
//             style={{
//               width: "100%",
//               background: "linear-gradient(135deg,#25d366,#128c7e)",
//               color: "#fff",
//               border: "none",
//               borderRadius: 10,
//               padding: "11px",
//               fontSize: 13,
//               fontWeight: 700,
//               cursor: "pointer",
//               fontFamily: "DM Sans,sans-serif",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 8,
//             }}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//               <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//             </svg>
//             Send via WhatsApp
//           </button>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Send via WhatsApp" to share directly.
//             <br />
//             On desktop: use "Open Full PDF" to view, or "Download PDF" to save.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

///////////////////////// test codes////////
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ✅ Services loaded dynamically from hospital's saved services
// // ✅ PDF send — NO auto download, only WhatsApp/Share
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext";

// // ✅ Fallback services by specialty
// const DEFAULT_SERVICES_BY_TYPE = {
//   dental: [
//     "General Checkup & Cleaning",
//     "Cosmetic Dentistry / Smile Makeover",
//     "Dental Implants",
//     "Orthodontics / Invisalign",
//     "Root Canal Therapy",
//     "Pediatric Dentistry",
//     "Oral Surgery",
//     "Periodontal Treatment",
//     "Teeth Whitening",
//     "Emergency Dental Care",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ayurved: [
//     "Panchakarma Detox",
//     "Shirodhara Therapy",
//     "Abhyanga Full Body Massage",
//     "Nasya Treatment",
//     "Kati Basti Back Pain Relief",
//     "Skin & Beauty Treatments",
//     "Herbal Consultation",
//     "Rasayana Therapy",
//     "Yoga & Pranayama",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ortho: [
//     "Joint Replacement Surgery",
//     "Sports Injury Treatment",
//     "Knee Replacement",
//     "Spine Surgery",
//     "Physiotherapy & Rehabilitation",
//     "Arthritis Management",
//     "Fracture Treatment",
//     "Arthroscopy",
//     "Post-Op Rehabilitation",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   eye: [
//     "LASIK Laser Eye Surgery",
//     "Cataract Surgery",
//     "Glaucoma Treatment",
//     "Retina Treatment",
//     "Squint Correction",
//     "Pediatric Ophthalmology",
//     "Eye Checkup",
//     "Contact Lens Fitting",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   cardiology: [
//     "Coronary Angiography",
//     "Angioplasty & Stenting",
//     "Open Heart Surgery CABG",
//     "Pacemaker Implantation",
//     "Preventive Cardiology",
//     "Pediatric Cardiology",
//     "ECG & Stress Test",
//     "Echocardiography",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   pediatric: [
//     "Newborn & Neonatal Care",
//     "Vaccination & Immunization",
//     "Growth & Development Monitoring",
//     "Child Nutrition Counseling",
//     "Pediatric Respiratory Care",
//     "24/7 Pediatric Emergency",
//     "Well Baby Checkup",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   general: [
//     "General Medicine & OPD",
//     "Pathology & Diagnostics",
//     "Emergency & Trauma Care",
//     "Orthopedics & Joint Care",
//     "Cardiology & Heart Care",
//     "Gynecology & Maternity Care",
//     "ENT Treatment",
//     "Dermatology",
//     "Follow-Up Visit",
//     "Other",
//   ],
// };

// // ✅ Get hospitalId from any saved token
// function getHospitalIdFromAnyToken() {
//   try {
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         const token = localStorage.getItem(key);
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//   } catch (_) {}
//   return null;
// }

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const { hospital } = useHospital();
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [servicesList, setServicesList] = useState([]); // ✅ dynamic
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   // ✅ Load services dynamically from this hospital's saved services
//   useEffect(() => {
//     const type = (hospital?.type || "dental").toLowerCase();
//     const hospitalId = getHospitalIdFromAnyToken();
//     const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
//     api
//       .get(url)
//       .then((data) => {
//         if (Array.isArray(data) && data.length > 0) {
//           const names = data.map((s) => s.name);
//           if (!names.includes("Follow-Up Visit")) names.push("Follow-Up Visit");
//           if (!names.includes("Other")) names.push("Other");
//           setServicesList(names);
//         } else {
//           setServicesList(
//             DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//           );
//         }
//       })
//       .catch(() =>
//         setServicesList(
//           DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//         ),
//       );
//   }, [hospital?.type]);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             isFollowUp: true,
//             status: "pending",
//             hospitalId: hospital?._id || null,
//           });
//         } catch (_) {}
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*${hospital.name}* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 ${hospital.phone}`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ".",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ──────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ────────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => setSelectedPatient(null)}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {/* ✅ Dynamic services from this hospital */}
//                 {servicesList.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           {/* Prescription Table */}
//           <style>{`
//             @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
//             @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* DESKTOP TABLE */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* MOBILE CARDS */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to ${hospital.name}!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family.\n\n_Wishing you great health!_\n— *${hospital.name} Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           hospital={hospital}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database ─────────────────────────────────────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
// ];

// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 2) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   return fetch(
//     (process.env.REACT_APP_API_URL || "http://localhost:5000/api") +
//       "/custommeds",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         ...(localStorage.getItem("pearlsmile_token")
//           ? {
//               Authorization:
//                 "Bearer " + localStorage.getItem("pearlsmile_token"),
//             }
//           : {}),
//       },
//       body: JSON.stringify({ name: name.trim(), cat: "Custom" }),
//     },
//   )
//     .then((r) => (r.ok ? r.json() : null))
//     .catch((err) => {
//       console.warn("Custom med save failed:", err);
//       return null;
//     });
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase(),
//         catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null),
//     wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });
//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };
//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, matches.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };
//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") hide();
//   };
//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0) {
//         if (!inpRef.current) return;
//         const r = inpRef.current.getBoundingClientRect();
//         const spaceBelow = window.innerHeight - r.bottom;
//         const dropH = Math.min(220, sugs.length * 36);
//         const top =
//           spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//         setDropPos({ top, left: r.left, width: r.width });
//       }
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);
//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null),
//     wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0),
//     queryEndRef = React.useRef(0);
//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };
//   const handleChange = (e) => {
//     const ta = e.target,
//       val = ta.value,
//       cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };
//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };
//   const selectMed = (name) => {
//     const ta = taRef.current,
//       val = ta.value;
//     const before = val.substring(0, queryStartRef.current),
//       after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     taRef.current.value.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);
//   return (
//     <>
//       <style>{`.med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}.med-suggestion-item:last-child{border-bottom:none;}.med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}.med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}.med-sug-name{font-weight:500;flex:1;color:#1a1614;}.med-sug-name b{color:#0d7377;font-weight:700;}.med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}`}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal ─────────────────────────────────────────
// // ✅ NO auto-download — only WhatsApp share or manual open
// function PrescriptionModal({
//   visit,
//   patient,
//   doctor,
//   hospital,
//   onClose,
//   showNotify,
// }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   const hospitalName = hospital?.name || "PearlSmile Dental Hospital";
//   const hospitalAddress = hospital?.address || "12, Dental Plaza, MG Road";
//   const hospitalCity = hospital?.city || "Pune - 411001";
//   const hospitalPhone = hospital?.phone || "+91 87936 08083";
//   const hospitalEmail = hospital?.email || "care@pearlsmiledental.in";
//   const hospitalTagline = hospital?.tagline || "Dental Hospital";
//   const stampText = hospitalName.toUpperCase().split(" ").slice(0, 2).join(" ");
//   const headerLine1 = hospitalName.toUpperCase().split(" ")[0];
//   const headerLine2 =
//     hospitalName.toUpperCase().split(" ").slice(1).join(" ") ||
//     hospitalTagline.toUpperCase();

//   useEffect(() => {
//     generatePDF();
//   }, []);
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };
//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;
//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240],
//       WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254];
//     const LGRAY3 = [240, 243, 248],
//       GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95],
//       GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);
//     const visitDate = visit.visitDate || "",
//       visitTime = visit.visitTime || "",
//       notes = visit.notes || "",
//       nextDate = visit.nextVisitDate || "",
//       service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate),
//       visitTimeFmt = fmtTimeLocal(visitTime),
//       nextDateFmt = fmtDateLocal(nextDate);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Health Care", 14, 38.5);
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(headerLine1, W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(headerLine2, W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text(hospitalPhone + "  |  " + hospitalEmail, W - 10, 38.5, {
//       align: "right",
//     });
//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }
//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);
//     let tableEndY = notesTop + notesBoxH + 8;
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text(headerLine1, W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();
//     const sigY = Math.max(advY + 28, H - 55),
//       cx = W - 46,
//       cy = sigY + 13,
//       R = 18;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");
//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);
//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3),
//       topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }
//     pdf.setFontSize(5.5);
//     const botStr = stampText,
//       botSpan = Math.min(botStr.length * 0.175, 1.4),
//       botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }
//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");
//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text(hospitalName, 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(hospitalPhone, 10, H - 9.5);
//     pdf.text(hospitalEmail, W / 2, H - 9.5, { align: "center" });
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from " +
//         hospitalName +
//         ". Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";
//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;
//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     )
//       setCanNativeShare(true);
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   // ✅ NO auto-download — only WhatsApp share
//   const shareViaWhatsApp = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });

//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       // Mobile — native share sheet (WhatsApp visible)
//       navigator
//         .share({
//           title: "Digital Prescription — " + hospitalName,
//           text: "Dear Patient, please find your digital prescription.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError" && rxMobile) {
//             const waMsg = encodeURIComponent(
//               "Dear Patient, your digital prescription is ready. Please contact us to receive the PDF.",
//             );
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             );
//           }
//         });
//     } else {
//       // Desktop — open WhatsApp with message (no auto-download)
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription is ready. Please use the 'Open Full PDF' button to view and download it.",
//         );
//         window.open("https://wa.me/" + rxMobile + "?text=" + waMsg, "_blank");
//         showNotify(
//           "WhatsApp Opened! ✓",
//           "Send the message to notify the patient.",
//         );
//       } else {
//         showNotify(
//           "No mobile number",
//           "Please add patient's mobile number first.",
//           true,
//         );
//       }
//     }
//   };

//   const downloadPDF = () => {
//     if (!pdfBlob) return;
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     showNotify(
//       "Downloaded ✓",
//       "Prescription PDF saved to your Downloads folder.",
//     );
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             {/* ✅ Open Full PDF button */}
//             <button
//               onClick={openFullPreview}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               🔍 Open Full PDF
//             </button>
//             {/* ✅ Download button — only when explicitly clicked */}
//             <button
//               onClick={downloadPDF}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               ⬇️ Download PDF
//             </button>
//           </div>
//           {/* ✅ WhatsApp share — NO auto-download */}
//           <button
//             onClick={shareViaWhatsApp}
//             style={{
//               width: "100%",
//               background: "linear-gradient(135deg,#25d366,#128c7e)",
//               color: "#fff",
//               border: "none",
//               borderRadius: 10,
//               padding: "11px",
//               fontSize: 13,
//               fontWeight: 700,
//               cursor: "pointer",
//               fontFamily: "DM Sans,sans-serif",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 8,
//             }}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//               <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//             </svg>
//             Send via WhatsApp
//           </button>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Send via WhatsApp" to share directly.
//             <br />
//             On desktop: use "Open Full PDF" to view, or "Download PDF" to save.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

/////////// fixed service taken ///////////
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ✅ Services loaded dynamically from hospital's saved services
// // ✅ PDF send — NO auto download, only WhatsApp/Share
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext";

// // ✅ Fallback services by specialty
// const DEFAULT_SERVICES_BY_TYPE = {
//   dental: [
//     "General Checkup & Cleaning",
//     "Cosmetic Dentistry / Smile Makeover",
//     "Dental Implants",
//     "Orthodontics / Invisalign",
//     "Root Canal Therapy",
//     "Pediatric Dentistry",
//     "Oral Surgery",
//     "Periodontal Treatment",
//     "Teeth Whitening",
//     "Emergency Dental Care",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ayurved: [
//     "Panchakarma Detox",
//     "Shirodhara Therapy",
//     "Abhyanga Full Body Massage",
//     "Nasya Treatment",
//     "Kati Basti Back Pain Relief",
//     "Skin & Beauty Treatments",
//     "Herbal Consultation",
//     "Rasayana Therapy",
//     "Yoga & Pranayama",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ortho: [
//     "Joint Replacement Surgery",
//     "Sports Injury Treatment",
//     "Knee Replacement",
//     "Spine Surgery",
//     "Physiotherapy & Rehabilitation",
//     "Arthritis Management",
//     "Fracture Treatment",
//     "Arthroscopy",
//     "Post-Op Rehabilitation",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   eye: [
//     "LASIK Laser Eye Surgery",
//     "Cataract Surgery",
//     "Glaucoma Treatment",
//     "Retina Treatment",
//     "Squint Correction",
//     "Pediatric Ophthalmology",
//     "Eye Checkup",
//     "Contact Lens Fitting",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   cardiology: [
//     "Coronary Angiography",
//     "Angioplasty & Stenting",
//     "Open Heart Surgery CABG",
//     "Pacemaker Implantation",
//     "Preventive Cardiology",
//     "Pediatric Cardiology",
//     "ECG & Stress Test",
//     "Echocardiography",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   pediatric: [
//     "Newborn & Neonatal Care",
//     "Vaccination & Immunization",
//     "Growth & Development Monitoring",
//     "Child Nutrition Counseling",
//     "Pediatric Respiratory Care",
//     "24/7 Pediatric Emergency",
//     "Well Baby Checkup",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   general: [
//     "General Medicine & OPD",
//     "Pathology & Diagnostics",
//     "Emergency & Trauma Care",
//     "Orthopedics & Joint Care",
//     "Cardiology & Heart Care",
//     "Gynecology & Maternity Care",
//     "ENT Treatment",
//     "Dermatology",
//     "Follow-Up Visit",
//     "Other",
//   ],
// };

// // ✅ Get hospitalId from any saved token
// function getHospitalIdFromAnyToken() {
//   try {
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         const token = localStorage.getItem(key);
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//   } catch (_) {}
//   return null;
// }

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const { hospital } = useHospital();
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [servicesList, setServicesList] = useState([]); // ✅ dynamic
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   // ✅ Load services dynamically from this hospital's saved services
//   useEffect(() => {
//     const type = (hospital?.type || "dental").toLowerCase();
//     // ✅ Use hospital._id directly — most reliable, fully isolated
//     const hospitalId = hospital?._id || getHospitalIdFromAnyToken();
//     const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
//     api
//       .get(url)
//       .then((data) => {
//         if (Array.isArray(data) && data.length > 0) {
//           const names = data.map((s) => s.name);
//           if (!names.includes("Follow-Up Visit")) names.push("Follow-Up Visit");
//           if (!names.includes("Other")) names.push("Other");
//           setServicesList(names);
//         } else {
//           setServicesList(
//             DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//           );
//         }
//       })
//       .catch(() =>
//         setServicesList(
//           DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//         ),
//       );
//   }, [hospital?._id, hospital?.type]); // ✅ reload when hospital or type changes

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             isFollowUp: true,
//             status: "pending",
//             hospitalId: hospital?._id || null,
//           });
//         } catch (_) {}
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*${hospital.name}* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 ${hospital.phone}`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ".",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ──────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ────────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => setSelectedPatient(null)}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {/* ✅ Dynamic services from this hospital */}
//                 {servicesList.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           {/* Prescription Table */}
//           <style>{`
//             @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
//             @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* DESKTOP TABLE */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* MOBILE CARDS */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to ${hospital.name}!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family.\n\n_Wishing you great health!_\n— *${hospital.name} Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           hospital={hospital}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database ─────────────────────────────────────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
// ];

// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 2) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   return fetch(
//     (process.env.REACT_APP_API_URL || "http://localhost:5000/api") +
//       "/custommeds",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         ...(localStorage.getItem("pearlsmile_token")
//           ? {
//               Authorization:
//                 "Bearer " + localStorage.getItem("pearlsmile_token"),
//             }
//           : {}),
//       },
//       body: JSON.stringify({ name: name.trim(), cat: "Custom" }),
//     },
//   )
//     .then((r) => (r.ok ? r.json() : null))
//     .catch((err) => {
//       console.warn("Custom med save failed:", err);
//       return null;
//     });
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase(),
//         catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null),
//     wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });
//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };
//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, matches.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };
//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") hide();
//   };
//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0) {
//         if (!inpRef.current) return;
//         const r = inpRef.current.getBoundingClientRect();
//         const spaceBelow = window.innerHeight - r.bottom;
//         const dropH = Math.min(220, sugs.length * 36);
//         const top =
//           spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//         setDropPos({ top, left: r.left, width: r.width });
//       }
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);
//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null),
//     wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0),
//     queryEndRef = React.useRef(0);
//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };
//   const handleChange = (e) => {
//     const ta = e.target,
//       val = ta.value,
//       cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };
//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };
//   const selectMed = (name) => {
//     const ta = taRef.current,
//       val = ta.value;
//     const before = val.substring(0, queryStartRef.current),
//       after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     taRef.current.value.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);
//   return (
//     <>
//       <style>{`.med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}.med-suggestion-item:last-child{border-bottom:none;}.med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}.med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}.med-sug-name{font-weight:500;flex:1;color:#1a1614;}.med-sug-name b{color:#0d7377;font-weight:700;}.med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}`}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal ─────────────────────────────────────────
// // ✅ NO auto-download — only WhatsApp share or manual open
// function PrescriptionModal({
//   visit,
//   patient,
//   doctor,
//   hospital,
//   onClose,
//   showNotify,
// }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   const hospitalName = hospital?.name || "PearlSmile Dental Hospital";
//   const hospitalAddress = hospital?.address || "12, Dental Plaza, MG Road";
//   const hospitalCity = hospital?.city || "Pune - 411001";
//   const hospitalPhone = hospital?.phone || "+91 87936 08083";
//   const hospitalEmail = hospital?.email || "care@pearlsmiledental.in";
//   const hospitalTagline = hospital?.tagline || "Dental Hospital";
//   const stampText = hospitalName.toUpperCase().split(" ").slice(0, 2).join(" ");
//   const headerLine1 = hospitalName.toUpperCase().split(" ")[0];
//   const headerLine2 =
//     hospitalName.toUpperCase().split(" ").slice(1).join(" ") ||
//     hospitalTagline.toUpperCase();

//   useEffect(() => {
//     generatePDF();
//   }, []);
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };
//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;
//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240],
//       WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254];
//     const LGRAY3 = [240, 243, 248],
//       GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95],
//       GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);
//     const visitDate = visit.visitDate || "",
//       visitTime = visit.visitTime || "",
//       notes = visit.notes || "",
//       nextDate = visit.nextVisitDate || "",
//       service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate),
//       visitTimeFmt = fmtTimeLocal(visitTime),
//       nextDateFmt = fmtDateLocal(nextDate);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Health Care", 14, 38.5);
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(headerLine1, W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(headerLine2, W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text(hospitalPhone + "  |  " + hospitalEmail, W - 10, 38.5, {
//       align: "right",
//     });
//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }
//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);
//     let tableEndY = notesTop + notesBoxH + 8;
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text(headerLine1, W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();
//     const sigY = Math.max(advY + 28, H - 55),
//       cx = W - 46,
//       cy = sigY + 13,
//       R = 18;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");
//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);
//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3),
//       topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }
//     pdf.setFontSize(5.5);
//     const botStr = stampText,
//       botSpan = Math.min(botStr.length * 0.175, 1.4),
//       botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }
//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");
//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text(hospitalName, 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(hospitalPhone, 10, H - 9.5);
//     pdf.text(hospitalEmail, W / 2, H - 9.5, { align: "center" });
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from " +
//         hospitalName +
//         ". Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";
//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;
//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     )
//       setCanNativeShare(true);
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   // ✅ NO auto-download — only WhatsApp share
//   const shareViaWhatsApp = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });

//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       // Mobile — native share sheet (WhatsApp visible)
//       navigator
//         .share({
//           title: "Digital Prescription — " + hospitalName,
//           text: "Dear Patient, please find your digital prescription.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError" && rxMobile) {
//             const waMsg = encodeURIComponent(
//               "Dear Patient, your digital prescription is ready. Please contact us to receive the PDF.",
//             );
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             );
//           }
//         });
//     } else {
//       // Desktop — open WhatsApp with message (no auto-download)
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription is ready. Please use the 'Open Full PDF' button to view and download it.",
//         );
//         window.open("https://wa.me/" + rxMobile + "?text=" + waMsg, "_blank");
//         showNotify(
//           "WhatsApp Opened! ✓",
//           "Send the message to notify the patient.",
//         );
//       } else {
//         showNotify(
//           "No mobile number",
//           "Please add patient's mobile number first.",
//           true,
//         );
//       }
//     }
//   };

//   const downloadPDF = () => {
//     if (!pdfBlob) return;
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     showNotify(
//       "Downloaded ✓",
//       "Prescription PDF saved to your Downloads folder.",
//     );
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             {/* ✅ Open Full PDF button */}
//             <button
//               onClick={openFullPreview}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               🔍 Open Full PDF
//             </button>
//             {/* ✅ Download button — only when explicitly clicked */}
//             <button
//               onClick={downloadPDF}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               ⬇️ Download PDF
//             </button>
//           </div>
//           {/* ✅ WhatsApp share — NO auto-download */}
//           <button
//             onClick={shareViaWhatsApp}
//             style={{
//               width: "100%",
//               background: "linear-gradient(135deg,#25d366,#128c7e)",
//               color: "#fff",
//               border: "none",
//               borderRadius: 10,
//               padding: "11px",
//               fontSize: 13,
//               fontWeight: 700,
//               cursor: "pointer",
//               fontFamily: "DM Sans,sans-serif",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 8,
//             }}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//               <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//             </svg>
//             Send via WhatsApp
//           </button>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Send via WhatsApp" to share directly.
//             <br />
//             On desktop: use "Open Full PDF" to view, or "Download PDF" to save.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

////////// medicines
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ✅ Services loaded dynamically from hospital's saved services
// // ✅ PDF send — NO auto download, only WhatsApp/Share
// // ✅ Medicine API search — 250,000 Indian medicines from MongoDB
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext";

// // ✅ API search for 250,000 Indian medicines from MongoDB
// const API_URL_MED =
//   process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// async function searchMedicinesAPI(query) {
//   try {
//     const res = await fetch(
//       `${API_URL_MED}/medicines?search=${encodeURIComponent(query)}&limit=8`,
//     );
//     const data = await res.json();
//     return Array.isArray(data) ? data : [];
//   } catch (_) {
//     return [];
//   }
// }

// // ✅ Fallback services by specialty
// const DEFAULT_SERVICES_BY_TYPE = {
//   dental: [
//     "General Checkup & Cleaning",
//     "Cosmetic Dentistry / Smile Makeover",
//     "Dental Implants",
//     "Orthodontics / Invisalign",
//     "Root Canal Therapy",
//     "Pediatric Dentistry",
//     "Oral Surgery",
//     "Periodontal Treatment",
//     "Teeth Whitening",
//     "Emergency Dental Care",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ayurved: [
//     "Panchakarma Detox",
//     "Shirodhara Therapy",
//     "Abhyanga Full Body Massage",
//     "Nasya Treatment",
//     "Kati Basti Back Pain Relief",
//     "Skin & Beauty Treatments",
//     "Herbal Consultation",
//     "Rasayana Therapy",
//     "Yoga & Pranayama",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ortho: [
//     "Joint Replacement Surgery",
//     "Sports Injury Treatment",
//     "Knee Replacement",
//     "Spine Surgery",
//     "Physiotherapy & Rehabilitation",
//     "Arthritis Management",
//     "Fracture Treatment",
//     "Arthroscopy",
//     "Post-Op Rehabilitation",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   eye: [
//     "LASIK Laser Eye Surgery",
//     "Cataract Surgery",
//     "Glaucoma Treatment",
//     "Retina Treatment",
//     "Squint Correction",
//     "Pediatric Ophthalmology",
//     "Eye Checkup",
//     "Contact Lens Fitting",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   cardiology: [
//     "Coronary Angiography",
//     "Angioplasty & Stenting",
//     "Open Heart Surgery CABG",
//     "Pacemaker Implantation",
//     "Preventive Cardiology",
//     "Pediatric Cardiology",
//     "ECG & Stress Test",
//     "Echocardiography",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   pediatric: [
//     "Newborn & Neonatal Care",
//     "Vaccination & Immunization",
//     "Growth & Development Monitoring",
//     "Child Nutrition Counseling",
//     "Pediatric Respiratory Care",
//     "24/7 Pediatric Emergency",
//     "Well Baby Checkup",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   general: [
//     "General Medicine & OPD",
//     "Pathology & Diagnostics",
//     "Emergency & Trauma Care",
//     "Orthopedics & Joint Care",
//     "Cardiology & Heart Care",
//     "Gynecology & Maternity Care",
//     "ENT Treatment",
//     "Dermatology",
//     "Follow-Up Visit",
//     "Other",
//   ],
// };

// function getHospitalIdFromAnyToken() {
//   try {
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         const token = localStorage.getItem(key);
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//   } catch (_) {}
//   return null;
// }

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }
// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }
// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }
// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const { hospital } = useHospital();
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [servicesList, setServicesList] = useState([]);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);
//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   useEffect(() => {
//     const type = (hospital?.type || "dental").toLowerCase();
//     const hospitalId = hospital?._id || getHospitalIdFromAnyToken();
//     const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
//     api
//       .get(url)
//       .then((data) => {
//         if (Array.isArray(data) && data.length > 0) {
//           const names = data.map((s) => s.name);
//           if (!names.includes("Follow-Up Visit")) names.push("Follow-Up Visit");
//           if (!names.includes("Other")) names.push("Other");
//           setServicesList(names);
//         } else {
//           setServicesList(
//             DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//           );
//         }
//       })
//       .catch(() =>
//         setServicesList(
//           DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//         ),
//       );
//   }, [hospital?._id, hospital?.type]);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);
//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             isFollowUp: true,
//             status: "pending",
//             hospitalId: hospital?._id || null,
//           });
//         } catch (_) {}
//       }
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*${hospital.name}* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 ${hospital.phone}`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ".",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />
//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>
//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => setSelectedPatient(null)}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {servicesList.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           <style>{`
//             @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
//             @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* DESKTOP TABLE */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* MOBILE CARDS */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to ${hospital.name}!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family.\n\n_Wishing you great health!_\n— *${hospital.name} Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           hospital={hospital}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database (local ~150 dental medicines) ──────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
// ];

// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 2) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   return fetch(
//     (process.env.REACT_APP_API_URL || "http://localhost:5000/api") +
//       "/custommeds",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         ...(localStorage.getItem("pearlsmile_token")
//           ? {
//               Authorization:
//                 "Bearer " + localStorage.getItem("pearlsmile_token"),
//             }
//           : {}),
//       },
//       body: JSON.stringify({ name: name.trim(), cat: "Custom" }),
//     },
//   )
//     .then((r) => (r.ok ? r.json() : null))
//     .catch((err) => {
//       console.warn("Custom med save failed:", err);
//       return null;
//     });
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase(),
//         catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null),
//     wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });
//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   // ✅ Async handleChange — local first, then 250k API fallback
//   const handleChange = async (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const localMatches = googleSearch(v, customMeds);
//     const apiMatches = await searchMedicinesAPI(v);
//     const localNames = new Set(localMatches.map((m) => m.name.toLowerCase()));
//     const merged = [
//       ...localMatches,
//       ...apiMatches.filter((m) => !localNames.has(m.name.toLowerCase())),
//     ].slice(0, 12);
//     if (!merged.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(merged);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, merged.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") hide();
//   };
//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0) {
//         if (!inpRef.current) return;
//         const r = inpRef.current.getBoundingClientRect();
//         const spaceBelow = window.innerHeight - r.bottom;
//         const dropH = Math.min(220, sugs.length * 36);
//         const top =
//           spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//         setDropPos({ top, left: r.left, width: r.width });
//       }
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null),
//     wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0),
//     queryEndRef = React.useRef(0);
//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };
//   const handleChange = (e) => {
//     const ta = e.target,
//       val = ta.value,
//       cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };
//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };
//   const selectMed = (name) => {
//     const ta = taRef.current,
//       val = ta.value;
//     const before = val.substring(0, queryStartRef.current),
//       after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     taRef.current.value.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`.med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}.med-suggestion-item:last-child{border-bottom:none;}.med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}.med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}.med-sug-name{font-weight:500;flex:1;color:#1a1614;}.med-sug-name b{color:#0d7377;font-weight:700;}.med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}`}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal ────────────────────────────────────────
// function PrescriptionModal({
//   visit,
//   patient,
//   doctor,
//   hospital,
//   onClose,
//   showNotify,
// }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   const hospitalName = hospital?.name || "PearlSmile Dental Hospital";
//   const hospitalAddress = hospital?.address || "12, Dental Plaza, MG Road";
//   const hospitalCity = hospital?.city || "Pune - 411001";
//   const hospitalPhone = hospital?.phone || "+91 87936 08083";
//   const hospitalEmail = hospital?.email || "care@pearlsmiledental.in";
//   const hospitalTagline = hospital?.tagline || "Dental Hospital";
//   const stampText = hospitalName.toUpperCase().split(" ").slice(0, 2).join(" ");
//   const headerLine1 = hospitalName.toUpperCase().split(" ")[0];
//   const headerLine2 =
//     hospitalName.toUpperCase().split(" ").slice(1).join(" ") ||
//     hospitalTagline.toUpperCase();

//   useEffect(() => {
//     generatePDF();
//   }, []);
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };
//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;
//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240],
//       WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254];
//     const LGRAY3 = [240, 243, 248],
//       GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95],
//       GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);
//     const visitDate = visit.visitDate || "",
//       visitTime = visit.visitTime || "",
//       notes = visit.notes || "",
//       nextDate = visit.nextVisitDate || "",
//       service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate),
//       visitTimeFmt = fmtTimeLocal(visitTime),
//       nextDateFmt = fmtDateLocal(nextDate);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Health Care", 14, 38.5);
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(headerLine1, W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(headerLine2, W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text(hospitalPhone + "  |  " + hospitalEmail, W - 10, 38.5, {
//       align: "right",
//     });
//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }
//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);
//     let tableEndY = notesTop + notesBoxH + 8;
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text(headerLine1, W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();
//     const sigY = Math.max(advY + 28, H - 55),
//       cx = W - 46,
//       cy = sigY + 13,
//       R = 18;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");
//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);
//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3),
//       topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }
//     pdf.setFontSize(5.5);
//     const botStr = stampText,
//       botSpan = Math.min(botStr.length * 0.175, 1.4),
//       botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }
//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");
//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text(hospitalName, 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(hospitalPhone, 10, H - 9.5);
//     pdf.text(hospitalEmail, W / 2, H - 9.5, { align: "center" });
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from " +
//         hospitalName +
//         ". Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";
//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;
//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     )
//       setCanNativeShare(true);
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const shareViaWhatsApp = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — " + hospitalName,
//           text: "Dear Patient, please find your digital prescription.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError" && rxMobile) {
//             const waMsg = encodeURIComponent(
//               "Dear Patient, your digital prescription is ready. Please contact us to receive the PDF.",
//             );
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             );
//           }
//         });
//     } else {
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription is ready. Please use the 'Open Full PDF' button to view and download it.",
//         );
//         window.open("https://wa.me/" + rxMobile + "?text=" + waMsg, "_blank");
//         showNotify(
//           "WhatsApp Opened! ✓",
//           "Send the message to notify the patient.",
//         );
//       } else {
//         showNotify(
//           "No mobile number",
//           "Please add patient's mobile number first.",
//           true,
//         );
//       }
//     }
//   };

//   const downloadPDF = () => {
//     if (!pdfBlob) return;
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     showNotify(
//       "Downloaded ✓",
//       "Prescription PDF saved to your Downloads folder.",
//     );
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               🔍 Open Full PDF
//             </button>
//             <button
//               onClick={downloadPDF}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               ⬇️ Download PDF
//             </button>
//           </div>
//           <button
//             onClick={shareViaWhatsApp}
//             style={{
//               width: "100%",
//               background: "linear-gradient(135deg,#25d366,#128c7e)",
//               color: "#fff",
//               border: "none",
//               borderRadius: 10,
//               padding: "11px",
//               fontSize: 13,
//               fontWeight: 700,
//               cursor: "pointer",
//               fontFamily: "DM Sans,sans-serif",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 8,
//             }}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//               <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//             </svg>
//             Send via WhatsApp
//           </button>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Send via WhatsApp" to share directly.
//             <br />
//             On desktop: use "Open Full PDF" to view, or "Download PDF" to save.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// above is corrected and file code
// // view lab report
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ✅ Services loaded dynamically from hospital's saved services
// // ✅ PDF send — NO auto download, only WhatsApp/Share
// // ✅ Medicine API search — 250,000 Indian medicines from MongoDB
// // ✅ NEW: Lab Reports section — per patient, per hospital isolated
// //         Doctor can add (file upload OR URL), view, delete
// //         Shows exact date & time of upload
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext";

// // ✅ API search for 250,000 Indian medicines from MongoDB
// const API_URL_MED =
//   process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// async function searchMedicinesAPI(query) {
//   try {
//     const res = await fetch(
//       `${API_URL_MED}/medicines?search=${encodeURIComponent(query)}&limit=8`,
//     );
//     const data = await res.json();
//     return Array.isArray(data) ? data : [];
//   } catch (_) {
//     return [];
//   }
// }

// // ✅ Fallback services by specialty
// const DEFAULT_SERVICES_BY_TYPE = {
//   dental: [
//     "General Checkup & Cleaning",
//     "Cosmetic Dentistry / Smile Makeover",
//     "Dental Implants",
//     "Orthodontics / Invisalign",
//     "Root Canal Therapy",
//     "Pediatric Dentistry",
//     "Oral Surgery",
//     "Periodontal Treatment",
//     "Teeth Whitening",
//     "Emergency Dental Care",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ayurved: [
//     "Panchakarma Detox",
//     "Shirodhara Therapy",
//     "Abhyanga Full Body Massage",
//     "Nasya Treatment",
//     "Kati Basti Back Pain Relief",
//     "Skin & Beauty Treatments",
//     "Herbal Consultation",
//     "Rasayana Therapy",
//     "Yoga & Pranayama",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ortho: [
//     "Joint Replacement Surgery",
//     "Sports Injury Treatment",
//     "Knee Replacement",
//     "Spine Surgery",
//     "Physiotherapy & Rehabilitation",
//     "Arthritis Management",
//     "Fracture Treatment",
//     "Arthroscopy",
//     "Post-Op Rehabilitation",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   eye: [
//     "LASIK Laser Eye Surgery",
//     "Cataract Surgery",
//     "Glaucoma Treatment",
//     "Retina Treatment",
//     "Squint Correction",
//     "Pediatric Ophthalmology",
//     "Eye Checkup",
//     "Contact Lens Fitting",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   cardiology: [
//     "Coronary Angiography",
//     "Angioplasty & Stenting",
//     "Open Heart Surgery CABG",
//     "Pacemaker Implantation",
//     "Preventive Cardiology",
//     "Pediatric Cardiology",
//     "ECG & Stress Test",
//     "Echocardiography",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   pediatric: [
//     "Newborn & Neonatal Care",
//     "Vaccination & Immunization",
//     "Growth & Development Monitoring",
//     "Child Nutrition Counseling",
//     "Pediatric Respiratory Care",
//     "24/7 Pediatric Emergency",
//     "Well Baby Checkup",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   general: [
//     "General Medicine & OPD",
//     "Pathology & Diagnostics",
//     "Emergency & Trauma Care",
//     "Orthopedics & Joint Care",
//     "Cardiology & Heart Care",
//     "Gynecology & Maternity Care",
//     "ENT Treatment",
//     "Dermatology",
//     "Follow-Up Visit",
//     "Other",
//   ],
// };

// function getHospitalIdFromAnyToken() {
//   try {
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         const token = localStorage.getItem(key);
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//   } catch (_) {}
//   return null;
// }

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }
// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }
// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }
// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// // ✅ NEW — format uploadedAt timestamp nicely
// function fmtUploadedAt(dateVal) {
//   if (!dateVal) return "";
//   const d = new Date(dateVal);
//   if (isNaN(d.getTime())) return "";
//   const day = d.getDate();
//   const mon = MONTHS_SHORT[d.getMonth()];
//   const yr = d.getFullYear();
//   const hh = d.getHours(),
//     mm = String(d.getMinutes()).padStart(2, "0");
//   const ampm = hh < 12 ? "AM" : "PM";
//   const hh12 = hh % 12 || 12;
//   return `${day} ${mon} ${yr}  •  ${hh12}:${mm} ${ampm}`;
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const { hospital } = useHospital();
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [servicesList, setServicesList] = useState([]);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   // ✅ NEW — Lab Reports state
//   const [labReports, setLabReports] = useState([]);
//   const [labName, setLabName] = useState("");
//   const [labUrl, setLabUrl] = useState("");
//   const [labSaving, setLabSaving] = useState(false);
//   const [labUploading, setLabUploading] = useState(false);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   useEffect(() => {
//     const type = (hospital?.type || "dental").toLowerCase();
//     const hospitalId = hospital?._id || getHospitalIdFromAnyToken();
//     const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
//     api
//       .get(url)
//       .then((data) => {
//         if (Array.isArray(data) && data.length > 0) {
//           const names = data.map((s) => s.name);
//           if (!names.includes("Follow-Up Visit")) names.push("Follow-Up Visit");
//           if (!names.includes("Other")) names.push("Other");
//           setServicesList(names);
//         } else {
//           setServicesList(
//             DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//           );
//         }
//       })
//       .catch(() =>
//         setServicesList(
//           DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//         ),
//       );
//   }, [hospital?._id, hospital?.type]);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       // ✅ NEW — load lab reports for this patient
//       setLabReports(full.labReports || []);
//       setLabName("");
//       setLabUrl("");
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);
//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             isFollowUp: true,
//             status: "pending",
//             hospitalId: hospital?._id || null,
//           });
//         } catch (_) {}
//       }
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*${hospital.name}* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 ${hospital.phone}`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ".",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ✅ NEW — Save Lab Report to MongoDB (POST /api/patients/:id/labreports)
//   const saveLabReport = async () => {
//     if (!labName.trim()) {
//       showNotify("Error", "Please enter a report name.", true);
//       return;
//     }
//     if (!labUrl.trim()) {
//       showNotify("Error", "Please upload a file or paste a URL.", true);
//       return;
//     }
//     setLabSaving(true);
//     try {
//       const result = await api.post(
//         "/patients/" + selectedPatient._id + "/labreports",
//         {
//           name: labName.trim(),
//           url: labUrl.trim(),
//         },
//       );
//       setLabReports(result.labReports || []);
//       setLabName("");
//       setLabUrl("");
//       showNotify(
//         "Lab Report Saved! ✓",
//         "Report saved permanently to patient profile.",
//       );
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLabSaving(false);
//   };

//   // ✅ NEW — Delete Lab Report (DELETE /api/patients/:id/labreports/:reportId)
//   const deleteLabReport = async (reportId) => {
//     if (!window.confirm("Delete this lab report? This cannot be undone."))
//       return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/labreports/" + reportId,
//       );
//       setLabReports(result.labReports || []);
//       showNotify("Report Deleted", "Lab report removed.");
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />
//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>
//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => setSelectedPatient(null)}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {servicesList.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           <style>{`
//             @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
//             @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* DESKTOP TABLE */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* MOBILE CARDS */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to ${hospital.name}!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family.\n\n_Wishing you great health!_\n— *${hospital.name} Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>

//         {/* ✅ NEW — Patient Lab Reports Section */}
//         <div style={{ marginBottom: 28 }}>
//           <div className="admin-section-title" style={{ marginBottom: 4 }}>
//             🧪 Patient Lab Reports
//           </div>
//           <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
//             Upload or link lab reports for <strong>{p.name}</strong>. Stored
//             permanently. Only visible to this hospital.
//           </div>

//           {/* Add Report Form */}
//           <div
//             style={{
//               background: "#f8fafc",
//               border: "1.5px solid #e2e8f0",
//               borderRadius: 14,
//               padding: 18,
//               marginBottom: 20,
//             }}
//           >
//             <div style={{ marginBottom: 12 }}>
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 700,
//                   color: "#374151",
//                   marginBottom: 5,
//                   textTransform: "uppercase",
//                   letterSpacing: "0.4px",
//                 }}
//               >
//                 Report Name *
//               </div>
//               <input
//                 type="text"
//                 placeholder="e.g. Blood Test, OPG X-Ray, CBC Report, HbA1c"
//                 value={labName}
//                 onChange={(e) => setLabName(e.target.value)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter") saveLabReport();
//                 }}
//                 style={{
//                   width: "100%",
//                   padding: "10px 13px",
//                   borderRadius: 8,
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: 13,
//                   fontFamily: "DM Sans,sans-serif",
//                   outline: "none",
//                   background: "#fff",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//             <div style={{ marginBottom: 14 }}>
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 700,
//                   color: "#374151",
//                   marginBottom: 5,
//                   textTransform: "uppercase",
//                   letterSpacing: "0.4px",
//                 }}
//               >
//                 Attach File or Paste URL *
//               </div>
//               {/* Upload Button */}
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                   marginBottom: 8,
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <label
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 7,
//                     padding: "9px 18px",
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                     borderRadius: 8,
//                     fontSize: 13,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                     fontFamily: "DM Sans,sans-serif",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {labUploading ? "⏳ Reading..." : "📎 Upload File"}
//                   <input
//                     type="file"
//                     accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
//                     style={{ display: "none" }}
//                     onChange={(e) => {
//                       const file = e.target.files[0];
//                       if (!file) return;
//                       if (!labName.trim())
//                         setLabName(file.name.replace(/\.[^/.]+$/, ""));
//                       setLabUploading(true);
//                       setLabUrl("");
//                       const reader = new FileReader();
//                       reader.onload = (ev) => {
//                         setLabUrl(ev.target.result);
//                         setLabUploading(false);
//                       };
//                       reader.onerror = () => {
//                         showNotify("Error", "Could not read file.", true);
//                         setLabUploading(false);
//                       };
//                       reader.readAsDataURL(file);
//                     }}
//                   />
//                 </label>
//                 <span
//                   style={{
//                     fontSize: 12,
//                     color: "#94a3b8",
//                     fontStyle: "italic",
//                   }}
//                 >
//                   or paste a public link below
//                 </span>
//               </div>
//               {/* URL Input — hidden when file loaded */}
//               {!labUrl.startsWith("data:") && (
//                 <input
//                   type="url"
//                   placeholder="https://drive.google.com/file/d/...  or  https://cloudinary.com/..."
//                   value={labUrl}
//                   onChange={(e) => setLabUrl(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") saveLabReport();
//                   }}
//                   style={{
//                     width: "100%",
//                     padding: "10px 13px",
//                     borderRadius: 8,
//                     border: "1.5px solid #e2e8f0",
//                     fontSize: 13,
//                     fontFamily: "DM Sans,sans-serif",
//                     outline: "none",
//                     background: "#fff",
//                     boxSizing: "border-box",
//                   }}
//                 />
//               )}
//               {/* File loaded confirmation strip */}
//               {labUrl.startsWith("data:") && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 10,
//                     background: "#f0fdf4",
//                     border: "1.5px solid #86efac",
//                     borderRadius: 8,
//                     padding: "9px 14px",
//                   }}
//                 >
//                   <span style={{ fontSize: 20 }}>
//                     {labUrl.startsWith("data:image") ? "🖼️" : "📄"}
//                   </span>
//                   <span
//                     style={{
//                       fontSize: 13,
//                       color: "#16a34a",
//                       fontWeight: 600,
//                       flex: 1,
//                     }}
//                   >
//                     File loaded — ready to save
//                   </span>
//                   <button
//                     onClick={() => setLabUrl("")}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       color: "#dc2626",
//                       cursor: "pointer",
//                       fontSize: 13,
//                       fontWeight: 700,
//                       padding: "2px 6px",
//                     }}
//                   >
//                     ✕ Remove
//                   </button>
//                 </div>
//               )}
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//                 flexWrap: "wrap",
//               }}
//             >
//               <button
//                 onClick={saveLabReport}
//                 disabled={labSaving || labUploading}
//                 style={{
//                   padding: "10px 24px",
//                   background:
//                     labSaving || labUploading
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 8,
//                   fontSize: 13,
//                   fontWeight: 700,
//                   cursor: labSaving || labUploading ? "not-allowed" : "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {labSaving
//                   ? "Saving..."
//                   : labUploading
//                     ? "Loading file..."
//                     : "💾 Save Report"}
//               </button>
//               <span style={{ fontSize: 11, color: "#94a3b8" }}>
//                 💡 Supports PDF, images, Word, Excel. For large files use Google
//                 Drive / Cloudinary link.
//               </span>
//             </div>
//           </div>

//           {/* Reports List */}
//           {labReports.length === 0 ? (
//             <div style={{ color: "#94a3b8", fontSize: 13, padding: "8px 0" }}>
//               No lab reports saved yet for {p.name}. Add the first report above.
//             </div>
//           ) : (
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               {labReports.map((report, i) => (
//                 <div
//                   key={report._id || i}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 12,
//                     background: "#fff",
//                     border: "1.5px solid #e2e8f0",
//                     borderRadius: 12,
//                     padding: "13px 16px",
//                     boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
//                   }}
//                 >
//                   {/* Icon */}
//                   <div
//                     style={{
//                       width: 44,
//                       height: 44,
//                       background: "rgba(13,115,119,0.08)",
//                       borderRadius: 10,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 22,
//                       flexShrink: 0,
//                     }}
//                   >
//                     {(report.url || "").startsWith("data:image") ? "🖼️" : "🧪"}
//                   </div>
//                   {/* Info */}
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontWeight: 700,
//                         fontSize: 14,
//                         color: "#0a1628",
//                         marginBottom: 3,
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {report.name}
//                     </div>
//                     <div
//                       style={{
//                         fontSize: 11,
//                         color: "#94a3b8",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 4,
//                       }}
//                     >
//                       <span>🕐</span>
//                       <span>{fmtUploadedAt(report.uploadedAt)}</span>
//                     </div>
//                   </div>
//                   {/* View Button — handles both data: URLs and https:// URLs */}
//                   <button
//                     onClick={() => {
//                       const url = report.url || "";
//                       if (url.startsWith("data:")) {
//                         // Convert base64 data URL → blob URL so browser can open it in new tab
//                         try {
//                           const [meta, base64] = url.split(",");
//                           const mime = meta.match(/:(.*?);/)[1];
//                           const bytes = atob(base64);
//                           const arr = new Uint8Array(bytes.length);
//                           for (let i = 0; i < bytes.length; i++)
//                             arr[i] = bytes.charCodeAt(i);
//                           const blob = new Blob([arr], { type: mime });
//                           const blobUrl = URL.createObjectURL(blob);
//                           const win = window.open(blobUrl, "_blank");
//                           // Revoke after 60s to free memory
//                           setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
//                           if (!win)
//                             alert(
//                               "Popup blocked. Please allow popups for this site.",
//                             );
//                         } catch (e) {
//                           alert(
//                             "Could not open file. Try downloading instead.",
//                           );
//                         }
//                       } else {
//                         window.open(url, "_blank");
//                       }
//                     }}
//                     style={{
//                       padding: "8px 14px",
//                       background: "rgba(13,115,119,0.08)",
//                       color: "#0d7377",
//                       border: "1.5px solid rgba(13,115,119,0.2)",
//                       borderRadius: 8,
//                       fontSize: 12,
//                       fontWeight: 600,
//                       cursor: "pointer",
//                       whiteSpace: "nowrap",
//                       flexShrink: 0,
//                     }}
//                   >
//                     🔗 View
//                   </button>
//                   {/* Delete Button */}
//                   <button
//                     onClick={() => deleteLabReport(report._id)}
//                     style={{
//                       padding: "8px 12px",
//                       background: "#fef2f2",
//                       color: "#dc2626",
//                       border: "1.5px solid #fca5a5",
//                       borderRadius: 8,
//                       fontSize: 12,
//                       fontWeight: 600,
//                       cursor: "pointer",
//                       whiteSpace: "nowrap",
//                       flexShrink: 0,
//                     }}
//                   >
//                     🗑️ Delete
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           hospital={hospital}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database (local ~150 dental medicines) ──────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
// ];

// // ✅ saveCustomMed — calls api.post directly (no detached prop)
// function saveCustomMed(name) {
//   if (!name || name.trim().length < 2) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   return fetch(
//     (process.env.REACT_APP_API_URL || "http://localhost:5000/api") +
//       "/custommeds",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         ...(localStorage.getItem("pearlsmile_token")
//           ? {
//               Authorization:
//                 "Bearer " + localStorage.getItem("pearlsmile_token"),
//             }
//           : {}),
//       },
//       body: JSON.stringify({ name: name.trim(), cat: "Custom" }),
//     },
//   )
//     .then((r) => (r.ok ? r.json() : null))
//     .catch((err) => {
//       console.warn("Custom med save failed:", err);
//       return null;
//     });
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase(),
//         catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── RxMedInput — async 250k API + local search, portal dropdown ──
// function RxMedInput({ value, onChange, customMeds = [], onCustomSaved }) {
//   const inpRef = React.useRef(null),
//     wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });
//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   const handleChange = async (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const localMatches = googleSearch(v, customMeds);
//     const apiMatches = await searchMedicinesAPI(v);
//     const localNames = new Set(localMatches.map((m) => m.name.toLowerCase()));
//     const merged = [
//       ...localMatches,
//       ...apiMatches.filter((m) => !localNames.has(m.name.toLowerCase())),
//     ].slice(0, 12);
//     if (!merged.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(merged);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, merged.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") hide();
//   };

//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0 && inpRef.current) {
//         const r = inpRef.current.getBoundingClientRect();
//         const spaceBelow = window.innerHeight - r.bottom;
//         const dropH = Math.min(220, sugs.length * 36);
//         const top =
//           spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//         setDropPos({ top, left: r.left, width: r.width });
//       }
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// // ── MedAutocomplete — Doctor Notes textarea ───────────────────
// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null),
//     wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0),
//     queryEndRef = React.useRef(0);
//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };
//   const handleChange = (e) => {
//     const ta = e.target,
//       val = ta.value,
//       cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };
//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };
//   const selectMed = (name) => {
//     const ta = taRef.current,
//       val = ta.value;
//     const before = val.substring(0, queryStartRef.current),
//       after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     taRef.current.value.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`.med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}.med-suggestion-item:last-child{border-bottom:none;}.med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}.med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}.med-sug-name{font-weight:500;flex:1;color:#1a1614;}.med-sug-name b{color:#0d7377;font-weight:700;}.med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}`}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original from document 3 ───────
// function PrescriptionModal({
//   visit,
//   patient,
//   doctor,
//   hospital,
//   onClose,
//   showNotify,
// }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   const hospitalName = hospital?.name || "PearlSmile Dental Hospital";
//   const hospitalAddress = hospital?.address || "12, Dental Plaza, MG Road";
//   const hospitalCity = hospital?.city || "Pune - 411001";
//   const hospitalPhone = hospital?.phone || "+91 87936 08083";
//   const hospitalEmail = hospital?.email || "care@pearlsmiledental.in";
//   const hospitalTagline = hospital?.tagline || "Dental Hospital";
//   const stampText = hospitalName.toUpperCase().split(" ").slice(0, 2).join(" ");
//   const headerLine1 = hospitalName.toUpperCase().split(" ")[0];
//   const headerLine2 =
//     hospitalName.toUpperCase().split(" ").slice(1).join(" ") ||
//     hospitalTagline.toUpperCase();

//   useEffect(() => {
//     generatePDF();
//   }, []);
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };
//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;
//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240],
//       WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254];
//     const LGRAY3 = [240, 243, 248],
//       GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95],
//       GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);
//     const visitDate = visit.visitDate || "",
//       visitTime = visit.visitTime || "",
//       notes = visit.notes || "",
//       nextDate = visit.nextVisitDate || "",
//       service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate),
//       visitTimeFmt = fmtTimeLocal(visitTime),
//       nextDateFmt = fmtDateLocal(nextDate);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Health Care", 14, 38.5);
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(headerLine1, W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(headerLine2, W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text(hospitalPhone + "  |  " + hospitalEmail, W - 10, 38.5, {
//       align: "right",
//     });
//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }
//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);
//     let tableEndY = notesTop + notesBoxH + 8,
//       afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text(headerLine1, W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();
//     const sigY = Math.max(advY + 28, H - 55),
//       cx = W - 46,
//       cy = sigY + 13,
//       R = 18;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");
//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);
//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3),
//       topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }
//     pdf.setFontSize(5.5);
//     const botStr = stampText,
//       botSpan = Math.min(botStr.length * 0.175, 1.4),
//       botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }
//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");
//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text(hospitalName, 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(hospitalPhone, 10, H - 9.5);
//     pdf.text(hospitalEmail, W / 2, H - 9.5, { align: "center" });
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from " +
//         hospitalName +
//         ". Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";
//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;
//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     )
//       setCanNativeShare(true);
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };
//   const shareViaWhatsApp = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — " + hospitalName,
//           text: "Dear Patient, please find your digital prescription.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError" && rxMobile) {
//             const waMsg = encodeURIComponent(
//               "Dear Patient, your digital prescription is ready. Please contact us to receive the PDF.",
//             );
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             );
//           }
//         });
//     } else {
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription is ready.",
//         );
//         window.open("https://wa.me/" + rxMobile + "?text=" + waMsg, "_blank");
//         showNotify(
//           "WhatsApp Opened! ✓",
//           "Send the message to notify the patient.",
//         );
//       } else {
//         showNotify(
//           "No mobile number",
//           "Please add patient's mobile number first.",
//           true,
//         );
//       }
//     }
//   };
//   const downloadPDF = () => {
//     if (!pdfBlob) return;
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     showNotify(
//       "Downloaded ✓",
//       "Prescription PDF saved to your Downloads folder.",
//     );
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               🔍 Open Full PDF
//             </button>
//             <button
//               onClick={downloadPDF}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               ⬇️ Download PDF
//             </button>
//           </div>
//           <button
//             onClick={shareViaWhatsApp}
//             style={{
//               width: "100%",
//               background: "linear-gradient(135deg,#25d366,#128c7e)",
//               color: "#fff",
//               border: "none",
//               borderRadius: 10,
//               padding: "11px",
//               fontSize: 13,
//               fontWeight: 700,
//               cursor: "pointer",
//               fontFamily: "DM Sans,sans-serif",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 8,
//             }}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//               <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//             </svg>
//             Send via WhatsApp
//           </button>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Send via WhatsApp" to share directly.
//             <br />
//             On desktop: use "Open Full PDF" to view, or "Download PDF" to save.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

//////////// last stamp fix

// // ============================================================
// // src/components/admin/PatientsTab.js
// // ✅ Services loaded dynamically from hospital's saved services
// // ✅ PDF send — NO auto download, only WhatsApp/Share
// // ✅ Medicine API search — 250,000 Indian medicines from MongoDB
// // ✅ NEW: Lab Reports section — per patient, per hospital isolated
// //         Doctor can add (file upload OR URL), view, delete
// //         Shows exact date & time of upload
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";
// import { useHospital } from "../../context/HospitalContext";

// // ✅ API search for 250,000 Indian medicines from MongoDB
// const API_URL_MED =
//   process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// async function searchMedicinesAPI(query) {
//   try {
//     const res = await fetch(
//       `${API_URL_MED}/medicines?search=${encodeURIComponent(query)}&limit=8`,
//     );
//     const data = await res.json();
//     return Array.isArray(data) ? data : [];
//   } catch (_) {
//     return [];
//   }
// }

// // ✅ Fallback services by specialty
// const DEFAULT_SERVICES_BY_TYPE = {
//   dental: [
//     "General Checkup & Cleaning",
//     "Cosmetic Dentistry / Smile Makeover",
//     "Dental Implants",
//     "Orthodontics / Invisalign",
//     "Root Canal Therapy",
//     "Pediatric Dentistry",
//     "Oral Surgery",
//     "Periodontal Treatment",
//     "Teeth Whitening",
//     "Emergency Dental Care",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ayurved: [
//     "Panchakarma Detox",
//     "Shirodhara Therapy",
//     "Abhyanga Full Body Massage",
//     "Nasya Treatment",
//     "Kati Basti Back Pain Relief",
//     "Skin & Beauty Treatments",
//     "Herbal Consultation",
//     "Rasayana Therapy",
//     "Yoga & Pranayama",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   ortho: [
//     "Joint Replacement Surgery",
//     "Sports Injury Treatment",
//     "Knee Replacement",
//     "Spine Surgery",
//     "Physiotherapy & Rehabilitation",
//     "Arthritis Management",
//     "Fracture Treatment",
//     "Arthroscopy",
//     "Post-Op Rehabilitation",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   eye: [
//     "LASIK Laser Eye Surgery",
//     "Cataract Surgery",
//     "Glaucoma Treatment",
//     "Retina Treatment",
//     "Squint Correction",
//     "Pediatric Ophthalmology",
//     "Eye Checkup",
//     "Contact Lens Fitting",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   cardiology: [
//     "Coronary Angiography",
//     "Angioplasty & Stenting",
//     "Open Heart Surgery CABG",
//     "Pacemaker Implantation",
//     "Preventive Cardiology",
//     "Pediatric Cardiology",
//     "ECG & Stress Test",
//     "Echocardiography",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   pediatric: [
//     "Newborn & Neonatal Care",
//     "Vaccination & Immunization",
//     "Growth & Development Monitoring",
//     "Child Nutrition Counseling",
//     "Pediatric Respiratory Care",
//     "24/7 Pediatric Emergency",
//     "Well Baby Checkup",
//     "Follow-Up Visit",
//     "Other",
//   ],
//   general: [
//     "General Medicine & OPD",
//     "Pathology & Diagnostics",
//     "Emergency & Trauma Care",
//     "Orthopedics & Joint Care",
//     "Cardiology & Heart Care",
//     "Gynecology & Maternity Care",
//     "ENT Treatment",
//     "Dermatology",
//     "Follow-Up Visit",
//     "Other",
//   ],
// };

// function getHospitalIdFromAnyToken() {
//   try {
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key && key.startsWith("pearlsmile_token_")) {
//         const token = localStorage.getItem(key);
//         const payload = JSON.parse(atob(token.split(".")[1]));
//         if (payload?.hospitalId) return payload.hospitalId;
//       }
//     }
//   } catch (_) {}
//   return null;
// }

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }
// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }
// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }
// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// // ✅ NEW — format uploadedAt timestamp nicely
// function fmtUploadedAt(dateVal) {
//   if (!dateVal) return "";
//   const d = new Date(dateVal);
//   if (isNaN(d.getTime())) return "";
//   const day = d.getDate();
//   const mon = MONTHS_SHORT[d.getMonth()];
//   const yr = d.getFullYear();
//   const hh = d.getHours(),
//     mm = String(d.getMinutes()).padStart(2, "0");
//   const ampm = hh < 12 ? "AM" : "PM";
//   const hh12 = hh % 12 || 12;
//   return `${day} ${mon} ${yr}  •  ${hh12}:${mm} ${ampm}`;
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const { hospital } = useHospital();
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [servicesList, setServicesList] = useState([]);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   // ✅ NEW — Lab Reports state
//   const [labReports, setLabReports] = useState([]);
//   const [labName, setLabName] = useState("");
//   const [labUrl, setLabUrl] = useState("");
//   const [labSaving, setLabSaving] = useState(false);
//   const [labUploading, setLabUploading] = useState(false);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   useEffect(() => {
//     const type = (hospital?.type || "dental").toLowerCase();
//     const hospitalId = hospital?._id || getHospitalIdFromAnyToken();
//     const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
//     api
//       .get(url)
//       .then((data) => {
//         if (Array.isArray(data) && data.length > 0) {
//           const names = data.map((s) => s.name);
//           if (!names.includes("Follow-Up Visit")) names.push("Follow-Up Visit");
//           if (!names.includes("Other")) names.push("Other");
//           setServicesList(names);
//         } else {
//           setServicesList(
//             DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//           );
//         }
//       })
//       .catch(() =>
//         setServicesList(
//           DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
//         ),
//       );
//   }, [hospital?._id, hospital?.type]);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       // ✅ NEW — load lab reports for this patient
//       setLabReports(full.labReports || []);
//       setLabName("");
//       setLabUrl("");
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);
//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             isFollowUp: true,
//             status: "pending",
//             hospitalId: hospital?._id || null,
//           });
//         } catch (_) {}
//       }
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*${hospital.name}* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 ${hospital.phone}`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ".",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ✅ NEW — Save Lab Report to MongoDB (POST /api/patients/:id/labreports)
//   const saveLabReport = async () => {
//     if (!labName.trim()) {
//       showNotify("Error", "Please enter a report name.", true);
//       return;
//     }
//     if (!labUrl.trim()) {
//       showNotify("Error", "Please upload a file or paste a URL.", true);
//       return;
//     }
//     setLabSaving(true);
//     try {
//       const result = await api.post(
//         "/patients/" + selectedPatient._id + "/labreports",
//         {
//           name: labName.trim(),
//           url: labUrl.trim(),
//         },
//       );
//       setLabReports(result.labReports || []);
//       setLabName("");
//       setLabUrl("");
//       showNotify(
//         "Lab Report Saved! ✓",
//         "Report saved permanently to patient profile.",
//       );
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLabSaving(false);
//   };

//   // ✅ NEW — Delete Lab Report (DELETE /api/patients/:id/labreports/:reportId)
//   const deleteLabReport = async (reportId) => {
//     if (!window.confirm("Delete this lab report? This cannot be undone."))
//       return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/labreports/" + reportId,
//       );
//       setLabReports(result.labReports || []);
//       showNotify("Report Deleted", "Lab report removed.");
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />
//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>
//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => setSelectedPatient(null)}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {servicesList.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           <style>{`
//             @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
//             @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* DESKTOP TABLE */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* MOBILE CARDS */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to ${hospital.name}!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family.\n\n_Wishing you great health!_\n— *${hospital.name} Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>

//         {/* ✅ NEW — Patient Lab Reports Section */}
//         <div style={{ marginBottom: 28 }}>
//           <div className="admin-section-title" style={{ marginBottom: 4 }}>
//             🧪 Patient Lab Reports
//           </div>
//           <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
//             Upload or link lab reports for <strong>{p.name}</strong>. Stored
//             permanently. Only visible to this hospital.
//           </div>

//           {/* Add Report Form */}
//           <div
//             style={{
//               background: "#f8fafc",
//               border: "1.5px solid #e2e8f0",
//               borderRadius: 14,
//               padding: 18,
//               marginBottom: 20,
//             }}
//           >
//             <div style={{ marginBottom: 12 }}>
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 700,
//                   color: "#374151",
//                   marginBottom: 5,
//                   textTransform: "uppercase",
//                   letterSpacing: "0.4px",
//                 }}
//               >
//                 Report Name *
//               </div>
//               <input
//                 type="text"
//                 placeholder="e.g. Blood Test, OPG X-Ray, CBC Report, HbA1c"
//                 value={labName}
//                 onChange={(e) => setLabName(e.target.value)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter") saveLabReport();
//                 }}
//                 style={{
//                   width: "100%",
//                   padding: "10px 13px",
//                   borderRadius: 8,
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: 13,
//                   fontFamily: "DM Sans,sans-serif",
//                   outline: "none",
//                   background: "#fff",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//             <div style={{ marginBottom: 14 }}>
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 700,
//                   color: "#374151",
//                   marginBottom: 5,
//                   textTransform: "uppercase",
//                   letterSpacing: "0.4px",
//                 }}
//               >
//                 Attach File or Paste URL *
//               </div>
//               {/* Upload Button */}
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                   marginBottom: 8,
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <label
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 7,
//                     padding: "9px 18px",
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                     borderRadius: 8,
//                     fontSize: 13,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                     fontFamily: "DM Sans,sans-serif",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {labUploading ? "⏳ Reading..." : "📎 Upload File"}
//                   <input
//                     type="file"
//                     accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
//                     style={{ display: "none" }}
//                     onChange={(e) => {
//                       const file = e.target.files[0];
//                       if (!file) return;
//                       if (!labName.trim())
//                         setLabName(file.name.replace(/\.[^/.]+$/, ""));
//                       setLabUploading(true);
//                       setLabUrl("");
//                       const reader = new FileReader();
//                       reader.onload = (ev) => {
//                         setLabUrl(ev.target.result);
//                         setLabUploading(false);
//                       };
//                       reader.onerror = () => {
//                         showNotify("Error", "Could not read file.", true);
//                         setLabUploading(false);
//                       };
//                       reader.readAsDataURL(file);
//                     }}
//                   />
//                 </label>
//                 <span
//                   style={{
//                     fontSize: 12,
//                     color: "#94a3b8",
//                     fontStyle: "italic",
//                   }}
//                 >
//                   or paste a public link below
//                 </span>
//               </div>
//               {/* URL Input — hidden when file loaded */}
//               {!labUrl.startsWith("data:") && (
//                 <input
//                   type="url"
//                   placeholder="https://drive.google.com/file/d/...  or  https://cloudinary.com/..."
//                   value={labUrl}
//                   onChange={(e) => setLabUrl(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") saveLabReport();
//                   }}
//                   style={{
//                     width: "100%",
//                     padding: "10px 13px",
//                     borderRadius: 8,
//                     border: "1.5px solid #e2e8f0",
//                     fontSize: 13,
//                     fontFamily: "DM Sans,sans-serif",
//                     outline: "none",
//                     background: "#fff",
//                     boxSizing: "border-box",
//                   }}
//                 />
//               )}
//               {/* File loaded confirmation strip */}
//               {labUrl.startsWith("data:") && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 10,
//                     background: "#f0fdf4",
//                     border: "1.5px solid #86efac",
//                     borderRadius: 8,
//                     padding: "9px 14px",
//                   }}
//                 >
//                   <span style={{ fontSize: 20 }}>
//                     {labUrl.startsWith("data:image") ? "🖼️" : "📄"}
//                   </span>
//                   <span
//                     style={{
//                       fontSize: 13,
//                       color: "#16a34a",
//                       fontWeight: 600,
//                       flex: 1,
//                     }}
//                   >
//                     File loaded — ready to save
//                   </span>
//                   <button
//                     onClick={() => setLabUrl("")}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       color: "#dc2626",
//                       cursor: "pointer",
//                       fontSize: 13,
//                       fontWeight: 700,
//                       padding: "2px 6px",
//                     }}
//                   >
//                     ✕ Remove
//                   </button>
//                 </div>
//               )}
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//                 flexWrap: "wrap",
//               }}
//             >
//               <button
//                 onClick={saveLabReport}
//                 disabled={labSaving || labUploading}
//                 style={{
//                   padding: "10px 24px",
//                   background:
//                     labSaving || labUploading
//                       ? "#94a3b8"
//                       : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 8,
//                   fontSize: 13,
//                   fontWeight: 700,
//                   cursor: labSaving || labUploading ? "not-allowed" : "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {labSaving
//                   ? "Saving..."
//                   : labUploading
//                     ? "Loading file..."
//                     : "💾 Save Report"}
//               </button>
//               <span style={{ fontSize: 11, color: "#94a3b8" }}>
//                 💡 Supports PDF, images, Word, Excel. For large files use Google
//                 Drive / Cloudinary link.
//               </span>
//             </div>
//           </div>

//           {/* Reports List */}
//           {labReports.length === 0 ? (
//             <div style={{ color: "#94a3b8", fontSize: 13, padding: "8px 0" }}>
//               No lab reports saved yet for {p.name}. Add the first report above.
//             </div>
//           ) : (
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               {labReports.map((report, i) => (
//                 <div
//                   key={report._id || i}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 12,
//                     background: "#fff",
//                     border: "1.5px solid #e2e8f0",
//                     borderRadius: 12,
//                     padding: "13px 16px",
//                     boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
//                   }}
//                 >
//                   {/* Icon */}
//                   <div
//                     style={{
//                       width: 44,
//                       height: 44,
//                       background: "rgba(13,115,119,0.08)",
//                       borderRadius: 10,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 22,
//                       flexShrink: 0,
//                     }}
//                   >
//                     {(report.url || "").startsWith("data:image") ? "🖼️" : "🧪"}
//                   </div>
//                   {/* Info */}
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontWeight: 700,
//                         fontSize: 14,
//                         color: "#0a1628",
//                         marginBottom: 3,
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {report.name}
//                     </div>
//                     <div
//                       style={{
//                         fontSize: 11,
//                         color: "#94a3b8",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 4,
//                       }}
//                     >
//                       <span>🕐</span>
//                       <span>{fmtUploadedAt(report.uploadedAt)}</span>
//                     </div>
//                   </div>
//                   {/* View Button — handles both data: URLs and https:// URLs */}
//                   <button
//                     onClick={() => {
//                       const url = report.url || "";
//                       if (url.startsWith("data:")) {
//                         // Convert base64 data URL → blob URL so browser can open it in new tab
//                         try {
//                           const [meta, base64] = url.split(",");
//                           const mime = meta.match(/:(.*?);/)[1];
//                           const bytes = atob(base64);
//                           const arr = new Uint8Array(bytes.length);
//                           for (let i = 0; i < bytes.length; i++)
//                             arr[i] = bytes.charCodeAt(i);
//                           const blob = new Blob([arr], { type: mime });
//                           const blobUrl = URL.createObjectURL(blob);
//                           const win = window.open(blobUrl, "_blank");
//                           // Revoke after 60s to free memory
//                           setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
//                           if (!win)
//                             alert(
//                               "Popup blocked. Please allow popups for this site.",
//                             );
//                         } catch (e) {
//                           alert(
//                             "Could not open file. Try downloading instead.",
//                           );
//                         }
//                       } else {
//                         window.open(url, "_blank");
//                       }
//                     }}
//                     style={{
//                       padding: "8px 14px",
//                       background: "rgba(13,115,119,0.08)",
//                       color: "#0d7377",
//                       border: "1.5px solid rgba(13,115,119,0.2)",
//                       borderRadius: 8,
//                       fontSize: 12,
//                       fontWeight: 600,
//                       cursor: "pointer",
//                       whiteSpace: "nowrap",
//                       flexShrink: 0,
//                     }}
//                   >
//                     🔗 View
//                   </button>
//                   {/* Delete Button */}
//                   <button
//                     onClick={() => deleteLabReport(report._id)}
//                     style={{
//                       padding: "8px 12px",
//                       background: "#fef2f2",
//                       color: "#dc2626",
//                       border: "1.5px solid #fca5a5",
//                       borderRadius: 8,
//                       fontSize: 12,
//                       fontWeight: 600,
//                       cursor: "pointer",
//                       whiteSpace: "nowrap",
//                       flexShrink: 0,
//                     }}
//                   >
//                     🗑️ Delete
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           hospital={hospital}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database (local ~150 dental medicines) ──────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
// ];

// // ✅ saveCustomMed — calls api.post directly (no detached prop)
// function saveCustomMed(name) {
//   if (!name || name.trim().length < 2) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   return fetch(
//     (process.env.REACT_APP_API_URL || "http://localhost:5000/api") +
//       "/custommeds",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         ...(localStorage.getItem("pearlsmile_token")
//           ? {
//               Authorization:
//                 "Bearer " + localStorage.getItem("pearlsmile_token"),
//             }
//           : {}),
//       },
//       body: JSON.stringify({ name: name.trim(), cat: "Custom" }),
//     },
//   )
//     .then((r) => (r.ok ? r.json() : null))
//     .catch((err) => {
//       console.warn("Custom med save failed:", err);
//       return null;
//     });
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase(),
//         catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── RxMedInput — async 250k API + local search, portal dropdown ──
// function RxMedInput({ value, onChange, customMeds = [], onCustomSaved }) {
//   const inpRef = React.useRef(null),
//     wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });
//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   const handleChange = async (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const localMatches = googleSearch(v, customMeds);
//     const apiMatches = await searchMedicinesAPI(v);
//     const localNames = new Set(localMatches.map((m) => m.name.toLowerCase()));
//     const merged = [
//       ...localMatches,
//       ...apiMatches.filter((m) => !localNames.has(m.name.toLowerCase())),
//     ].slice(0, 12);
//     if (!merged.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(merged);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, merged.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") hide();
//   };

//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0 && inpRef.current) {
//         const r = inpRef.current.getBoundingClientRect();
//         const spaceBelow = window.innerHeight - r.bottom;
//         const dropH = Math.min(220, sugs.length * 36);
//         const top =
//           spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//         setDropPos({ top, left: r.left, width: r.width });
//       }
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// // ── MedAutocomplete — Doctor Notes textarea ───────────────────
// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null),
//     wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0),
//     queryEndRef = React.useRef(0);
//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };
//   const handleChange = (e) => {
//     const ta = e.target,
//       val = ta.value,
//       cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };
//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };
//   const selectMed = (name) => {
//     const ta = taRef.current,
//       val = ta.value;
//     const before = val.substring(0, queryStartRef.current),
//       after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     taRef.current.value.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`.med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}.med-suggestion-item:last-child{border-bottom:none;}.med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}.med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}.med-sug-name{font-weight:500;flex:1;color:#1a1614;}.med-sug-name b{color:#0d7377;font-weight:700;}.med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}`}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original from document 3 ───────
// function PrescriptionModal({
//   visit,
//   patient,
//   doctor,
//   hospital,
//   onClose,
//   showNotify,
// }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   const hospitalName = hospital?.name || "PearlSmile Dental Hospital";
//   const hospitalAddress = hospital?.address || "12, Dental Plaza, MG Road";
//   const hospitalCity = hospital?.city || "Pune - 411001";
//   const hospitalPhone = hospital?.phone || "+91 87936 08083";
//   const hospitalEmail = hospital?.email || "care@pearlsmiledental.in";
//   const hospitalTagline = hospital?.tagline || "Dental Hospital";
//   const stampText = hospitalName.toUpperCase().split(" ").slice(0, 2).join(" ");
//   const headerLine1 = hospitalName.toUpperCase().split(" ")[0];
//   const headerLine2 =
//     hospitalName.toUpperCase().split(" ").slice(1).join(" ") ||
//     hospitalTagline.toUpperCase();

//   useEffect(() => {
//     generatePDF();
//   }, []);
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };
//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;
//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240],
//       WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254];
//     const LGRAY3 = [240, 243, 248],
//       GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95],
//       GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);
//     const visitDate = visit.visitDate || "",
//       visitTime = visit.visitTime || "",
//       notes = visit.notes || "",
//       nextDate = visit.nextVisitDate || "",
//       service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate),
//       visitTimeFmt = fmtTimeLocal(visitTime),
//       nextDateFmt = fmtDateLocal(nextDate);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Health Care", 14, 38.5);
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(headerLine1, W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text(headerLine2, W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text(hospitalPhone + "  |  " + hospitalEmail, W - 10, 38.5, {
//       align: "right",
//     });
//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }
//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
//     // ✅ FIX: Dynamic notesBoxH — adapts to available space so stamp never overflows
//     const SIG_ZONE_START = H - 62; // stamp + footer need 62mm at bottom
//     const hasNext = !!nextDateFmt;
//     const reservedBelow = 8 + (hasNext ? 19 : 0) + 4 + 20 + 4; // tableGap + nextDate + gap + advBox + gap
//     const maxNotesBoxH = Math.max(
//       12,
//       SIG_ZONE_START - notesTop - 8 - reservedBelow,
//     );
//     const notesBoxH = Math.min(46, maxNotesBoxH);
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);
//     let tableEndY = notesTop + notesBoxH + 8,
//       afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text(headerLine1, W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();
//     // ✅ FIX: Stamp at FIXED absolute position — never overflows footer
//     const cx = W - 46,
//       cy = H - 47,
//       R = 18,
//       sigY = cy - 13;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");
//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);
//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3),
//       topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }
//     pdf.setFontSize(5.5);
//     const botStr = stampText,
//       botSpan = Math.min(botStr.length * 0.175, 1.4),
//       botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }
//     // ✅ FIX: Complete stamp center — vertical staff + horizontal crossbar + Rx symbol
//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 9, cx, cy + 8);
//     // Horizontal crossbar (makes proper cross)
//     pdf.setLineWidth(0.6);
//     pdf.line(cx - 5, cy - 3, cx + 5, cy - 3);
//     // Top decorative wings
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 8.5, cx - 4, cy - 10.5);
//     pdf.line(cx - 4, cy - 10.5, cx - 6, cy - 9);
//     pdf.line(cx - 6, cy - 9, cx - 3, cy - 7.5);
//     pdf.line(cx, cy - 8.5, cx + 4, cy - 10.5);
//     pdf.line(cx + 4, cy - 10.5, cx + 6, cy - 9);
//     pdf.line(cx + 6, cy - 9, cx + 3, cy - 7.5);
//     sf(INK);
//     pdf.circle(cx, cy - 9.2, 1, "F");
//     // Small horizontal lines on staff
//     pdf.setLineWidth(0.4);
//     pdf.line(cx - 3, cy + 1, cx + 3, cy + 1);
//     pdf.line(cx - 2, cy + 4, cx + 2, cy + 4);
//     // Center "Rx" text in stamp middle
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7);
//     pdf.text("Rx", cx, cy - 0.5, { align: "center" });
//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text(hospitalName, 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(hospitalPhone, 10, H - 9.5);
//     pdf.text(hospitalEmail, W / 2, H - 9.5, { align: "center" });
//     pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from " +
//         hospitalName +
//         ". Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";
//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;
//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     )
//       setCanNativeShare(true);
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };
//   const shareViaWhatsApp = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — " + hospitalName,
//           text: "Dear Patient, please find your digital prescription.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError" && rxMobile) {
//             const waMsg = encodeURIComponent(
//               "Dear Patient, your digital prescription is ready. Please contact us to receive the PDF.",
//             );
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             );
//           }
//         });
//     } else {
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription is ready.",
//         );
//         window.open("https://wa.me/" + rxMobile + "?text=" + waMsg, "_blank");
//         showNotify(
//           "WhatsApp Opened! ✓",
//           "Send the message to notify the patient.",
//         );
//       } else {
//         showNotify(
//           "No mobile number",
//           "Please add patient's mobile number first.",
//           true,
//         );
//       }
//     }
//   };
//   const downloadPDF = () => {
//     if (!pdfBlob) return;
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     showNotify(
//       "Downloaded ✓",
//       "Prescription PDF saved to your Downloads folder.",
//     );
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               🔍 Open Full PDF
//             </button>
//             <button
//               onClick={downloadPDF}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//             >
//               ⬇️ Download PDF
//             </button>
//           </div>
//           <button
//             onClick={shareViaWhatsApp}
//             style={{
//               width: "100%",
//               background: "linear-gradient(135deg,#25d366,#128c7e)",
//               color: "#fff",
//               border: "none",
//               borderRadius: 10,
//               padding: "11px",
//               fontSize: 13,
//               fontWeight: 700,
//               cursor: "pointer",
//               fontFamily: "DM Sans,sans-serif",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: 8,
//             }}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
//               <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//               <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//             </svg>
//             Send via WhatsApp
//           </button>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Send via WhatsApp" to share directly.
//             <br />
//             On desktop: use "Open Full PDF" to view, or "Download PDF" to save.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

/////////// above 100% correct just excel sheet below

// ============================================================
// src/components/admin/PatientsTab.js
// ✅ Services loaded dynamically from hospital's saved services
// ✅ PDF send — NO auto download, only WhatsApp/Share
// ✅ Medicine API search — 250,000 Indian medicines from MongoDB
// ✅ NEW: Lab Reports section — per patient, per hospital isolated
//         Doctor can add (file upload OR URL), view, delete
//         Shows exact date & time of upload
// ============================================================
import React, { useState, useEffect, useCallback } from "react";
import api from "../../utils/api";
import { useHospital } from "../../context/HospitalContext";

// ✅ API search for 250,000 Indian medicines from MongoDB
const API_URL_MED =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

async function searchMedicinesAPI(query) {
  try {
    const res = await fetch(
      `${API_URL_MED}/medicines?search=${encodeURIComponent(query)}&limit=8`,
    );
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (_) {
    return [];
  }
}

// ✅ Fallback services by specialty
const DEFAULT_SERVICES_BY_TYPE = {
  dental: [
    "General Checkup & Cleaning",
    "Cosmetic Dentistry / Smile Makeover",
    "Dental Implants",
    "Orthodontics / Invisalign",
    "Root Canal Therapy",
    "Pediatric Dentistry",
    "Oral Surgery",
    "Periodontal Treatment",
    "Teeth Whitening",
    "Emergency Dental Care",
    "Follow-Up Visit",
    "Other",
  ],
  ayurved: [
    "Panchakarma Detox",
    "Shirodhara Therapy",
    "Abhyanga Full Body Massage",
    "Nasya Treatment",
    "Kati Basti Back Pain Relief",
    "Skin & Beauty Treatments",
    "Herbal Consultation",
    "Rasayana Therapy",
    "Yoga & Pranayama",
    "Follow-Up Visit",
    "Other",
  ],
  ortho: [
    "Joint Replacement Surgery",
    "Sports Injury Treatment",
    "Knee Replacement",
    "Spine Surgery",
    "Physiotherapy & Rehabilitation",
    "Arthritis Management",
    "Fracture Treatment",
    "Arthroscopy",
    "Post-Op Rehabilitation",
    "Follow-Up Visit",
    "Other",
  ],
  eye: [
    "LASIK Laser Eye Surgery",
    "Cataract Surgery",
    "Glaucoma Treatment",
    "Retina Treatment",
    "Squint Correction",
    "Pediatric Ophthalmology",
    "Eye Checkup",
    "Contact Lens Fitting",
    "Follow-Up Visit",
    "Other",
  ],
  cardiology: [
    "Coronary Angiography",
    "Angioplasty & Stenting",
    "Open Heart Surgery CABG",
    "Pacemaker Implantation",
    "Preventive Cardiology",
    "Pediatric Cardiology",
    "ECG & Stress Test",
    "Echocardiography",
    "Follow-Up Visit",
    "Other",
  ],
  pediatric: [
    "Newborn & Neonatal Care",
    "Vaccination & Immunization",
    "Growth & Development Monitoring",
    "Child Nutrition Counseling",
    "Pediatric Respiratory Care",
    "24/7 Pediatric Emergency",
    "Well Baby Checkup",
    "Follow-Up Visit",
    "Other",
  ],
  general: [
    "General Medicine & OPD",
    "Pathology & Diagnostics",
    "Emergency & Trauma Care",
    "Orthopedics & Joint Care",
    "Cardiology & Heart Care",
    "Gynecology & Maternity Care",
    "ENT Treatment",
    "Dermatology",
    "Follow-Up Visit",
    "Other",
  ],
};

function getHospitalIdFromAnyToken() {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("pearlsmile_token_")) {
        const token = localStorage.getItem(key);
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload?.hospitalId) return payload.hospitalId;
      }
    }
  } catch (_) {}
  return null;
}

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function fmtDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
}
function fmtDateShort(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
}
function fmtTime(t) {
  if (!t) return "";
  const parts = t.split(":");
  const hh = parseInt(parts[0]),
    mm = parts[1];
  return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
}
function totalRevenue(visits = []) {
  return visits.reduce((sum, v) => {
    const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
    return sum + (isNaN(n) ? 0 : n);
  }, 0);
}

// ✅ NEW — format uploadedAt timestamp nicely
function fmtUploadedAt(dateVal) {
  if (!dateVal) return "";
  const d = new Date(dateVal);
  if (isNaN(d.getTime())) return "";
  const day = d.getDate();
  const mon = MONTHS_SHORT[d.getMonth()];
  const yr = d.getFullYear();
  const hh = d.getHours(),
    mm = String(d.getMinutes()).padStart(2, "0");
  const ampm = hh < 12 ? "AM" : "PM";
  const hh12 = hh % 12 || 12;
  return `${day} ${mon} ${yr}  •  ${hh12}:${mm} ${ampm}`;
}

// ✅ NEW — Load SheetJS dynamically for Excel export
function loadSheetJS() {
  return new Promise((resolve) => {
    if (window.XLSX) return resolve(true);
    if (document.getElementById("sheetjs-cdn")) {
      const check = setInterval(() => {
        if (window.XLSX) {
          clearInterval(check);
          resolve(true);
        }
      }, 100);
      return;
    }
    const s = document.createElement("script");
    s.id = "sheetjs-cdn";
    s.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
}

export default function PatientsTab({ showNotify, doctor }) {
  const { hospital } = useHospital();
  const [patients, setPatients] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewForm, setShowNewForm] = useState(false);
  const [servicesList, setServicesList] = useState([]);
  const [newPat, setNewPat] = useState({
    name: "",
    mobile: "",
    email: "",
    age: "",
    gender: "",
    blood: "",
  });
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [rxModal, setRxModal] = useState(null);
  const [customMeds, setCustomMeds] = useState([]);

  // ✅ NEW — Lab Reports state
  const [labReports, setLabReports] = useState([]);
  const [labName, setLabName] = useState("");
  const [labUrl, setLabUrl] = useState("");
  const [labSaving, setLabSaving] = useState(false);
  const [labUploading, setLabUploading] = useState(false);

  // ✅ NEW — Daily Report state
  const [reportDate, setReportDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [exporting, setExporting] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const nowTime = new Date().toTimeString().slice(0, 5);
  const [visitForm, setVisitForm] = useState({
    date: today,
    time: nowTime,
    service: "",
    amount: "",
    nextVisitDate: "",
    notes: "",
    rxRows: [
      {
        medicine: "",
        dosageParts: ["0", "0", "0"],
        dosageTiming: "after meal",
        dosage: "",
        duration: "",
        route: "ORAL",
      },
    ],
  });

  const loadPatients = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.get("/patients");
      setPatients(data);
      setFiltered(data);
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    loadPatients();
  }, [loadPatients]);

  useEffect(() => {
    api
      .get("/custommeds")
      .then((data) => {
        if (Array.isArray(data)) setCustomMeds(data);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const type = (hospital?.type || "dental").toLowerCase();
    const hospitalId = hospital?._id || getHospitalIdFromAnyToken();
    const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
    api
      .get(url)
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          const names = data.map((s) => s.name);
          if (!names.includes("Follow-Up Visit")) names.push("Follow-Up Visit");
          if (!names.includes("Other")) names.push("Other");
          setServicesList(names);
        } else {
          setServicesList(
            DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
          );
        }
      })
      .catch(() =>
        setServicesList(
          DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental,
        ),
      );
  }, [hospital?._id, hospital?.type]);

  const filterPatients = (q) => {
    const term = q.toLowerCase();
    setFiltered(
      patients.filter(
        (p) =>
          (p.name || "").toLowerCase().includes(term) ||
          (p.mobile || "").includes(term) ||
          (p.email || "").toLowerCase().includes(term),
      ),
    );
  };

  const createPatient = async () => {
    if (!newPat.name.trim()) {
      showNotify("Error", "Patient name is required.", true);
      return;
    }
    if (!newPat.mobile.trim()) {
      showNotify("Error", "Mobile number is required.", true);
      return;
    }
    try {
      await api.post("/patients", newPat);
      setNewPat({
        name: "",
        mobile: "",
        email: "",
        age: "",
        gender: "",
        blood: "",
      });
      setShowNewForm(false);
      showNotify(
        "Patient Profile Created! ✓",
        "New profile for " + newPat.name + " saved.",
      );
      loadPatients();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const openPatient = async (p) => {
    try {
      const full = await api.get("/patients/" + p._id);
      setSelectedPatient(full);
      // ✅ NEW — load lab reports for this patient
      setLabReports(full.labReports || []);
      setLabName("");
      setLabUrl("");
      setVisitForm({
        date: today,
        time: nowTime,
        service: "",
        amount: "",
        nextVisitDate: "",
        notes: "",
        rxRows: [
          {
            medicine: "",
            dosageParts: ["0", "0", "0"],
            dosageTiming: "after meal",
            dosage: "",
            duration: "",
            route: "ORAL",
          },
        ],
      });
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const deletePatient = async () => {
    if (
      !window.confirm(
        "Delete this patient profile and all their records? This cannot be undone.",
      )
    )
      return;
    try {
      await api.delete("/patients/" + selectedPatient._id);
      showNotify("Profile Deleted", "Patient profile removed.");
      setSelectedPatient(null);
      loadPatients();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const saveVisit = async () => {
    if (!visitForm.date) {
      showNotify("Missing Fields", "Please select a visit date.", true);
      return;
    }
    if (!visitForm.service) {
      showNotify("Missing Fields", "Please select a service.", true);
      return;
    }
    try {
      const payload = {
        visitDate: visitForm.date,
        visitTime: visitForm.time,
        service: visitForm.service,
        amount: visitForm.amount,
        nextVisitDate: visitForm.nextVisitDate,
        notes: visitForm.notes,
        doctor: doctor?.name || "",
        prescription: {
          medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
        },
      };
      const updated = await api.post(
        "/patients/" + selectedPatient._id + "/visits",
        payload,
      );
      setSelectedPatient(updated);
      if (visitForm.nextVisitDate && selectedPatient.mobile) {
        try {
          await api.post("/appointments", {
            name: selectedPatient.name,
            phone: selectedPatient.mobile,
            service: visitForm.service,
            date: visitForm.nextVisitDate,
            time: "",
            message: "Follow-up visit from Patient Profile",
            isFollowUp: true,
            status: "pending",
            hospitalId: hospital?._id || null,
          });
        } catch (_) {}
      }
      setVisitForm({
        date: today,
        time: nowTime,
        service: "",
        amount: "",
        nextVisitDate: "",
        notes: "",
        rxRows: [
          {
            medicine: "",
            dosageParts: ["0", "0", "0"],
            dosageTiming: "after meal",
            dosage: "",
            duration: "",
            route: "ORAL",
          },
        ],
      });
      const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
      if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
        let rawMobile = (selectedPatient.mobile || "").replace(
          /[\s\-\(\)\+]/g,
          "",
        );
        if (!rawMobile.startsWith("91") && rawMobile.length === 10)
          rawMobile = "91" + rawMobile;
        const waMsg = `*${hospital.name}* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 ${hospital.phone}`;
        setTimeout(
          () =>
            window.open(
              "https://wa.me/" +
                rawMobile +
                "?text=" +
                encodeURIComponent(waMsg),
              "_blank",
            ),
          500,
        );
        showNotify(
          "Visit Saved + Follow-Up Appointment Created!",
          "Reminder sent to " +
            selectedPatient.name +
            " for " +
            fmtDate(visitForm.nextVisitDate) +
            ".",
        );
      } else if (visitForm.nextVisitDate) {
        showNotify(
          "Visit Saved + Appointment Created! ✓",
          "Follow-up appointment for " +
            fmtDate(visitForm.nextVisitDate) +
            " added.",
        );
      } else {
        showNotify(
          "Visit Record Saved! ✓",
          "Patient visit has been recorded successfully.",
        );
      }
      loadPatients();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const deleteVisit = async (visitId) => {
    if (!window.confirm("Delete this visit record?")) return;
    try {
      const result = await api.delete(
        "/patients/" + selectedPatient._id + "/visits/" + visitId,
      );
      setSelectedPatient(result.patient);
      showNotify("Visit Deleted", "Visit record removed.");
      loadPatients();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const sendPrescription = (visit) => {
    const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
    setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
  };

  // ✅ NEW — Save Lab Report to MongoDB (POST /api/patients/:id/labreports)
  const saveLabReport = async () => {
    if (!labName.trim()) {
      showNotify("Error", "Please enter a report name.", true);
      return;
    }
    if (!labUrl.trim()) {
      showNotify("Error", "Please upload a file or paste a URL.", true);
      return;
    }
    setLabSaving(true);
    try {
      const result = await api.post(
        "/patients/" + selectedPatient._id + "/labreports",
        {
          name: labName.trim(),
          url: labUrl.trim(),
        },
      );
      setLabReports(result.labReports || []);
      setLabName("");
      setLabUrl("");
      showNotify(
        "Lab Report Saved! ✓",
        "Report saved permanently to patient profile.",
      );
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setLabSaving(false);
  };

  // ✅ NEW — Delete Lab Report (DELETE /api/patients/:id/labreports/:reportId)
  const deleteLabReport = async (reportId) => {
    if (!window.confirm("Delete this lab report? This cannot be undone."))
      return;
    try {
      const result = await api.delete(
        "/patients/" + selectedPatient._id + "/labreports/" + reportId,
      );
      setLabReports(result.labReports || []);
      showNotify("Report Deleted", "Lab report removed.");
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  // ✅ NEW — Export Daily Patient Report to Excel
  const exportDailyReport = async () => {
    setExporting(true);
    try {
      const ok = await loadSheetJS();
      if (!ok || !window.XLSX) {
        showNotify(
          "Error",
          "Could not load Excel library. Check your internet connection.",
          true,
        );
        setExporting(false);
        return;
      }
      const allPatients = await api.get("/patients");
      const rows = [];
      let srNo = 1;
      for (const pat of allPatients) {
        let fullPat;
        try {
          fullPat = await api.get("/patients/" + pat._id);
        } catch (_) {
          continue;
        }
        const dayVisits = (fullPat.visits || []).filter(
          (v) => v.visitDate === reportDate,
        );
        for (const v of dayVisits) {
          const medicines = (v.prescription?.medicineRows || [])
            .filter((r) => r.medicine && r.medicine.trim())
            .map((r) => {
              let med = r.medicine;
              if (r.dosage) med += " (" + r.dosage + ")";
              if (r.duration) med += " - " + r.duration;
              if (r.route && r.route !== "ORAL") med += " [" + r.route + "]";
              return med;
            })
            .join("; ");
          rows.push({
            "Sr No": srNo++,
            Date: fmtDateShort(v.visitDate),
            Time: v.visitTime ? fmtTime(v.visitTime) : "—",
            "Patient Name": fullPat.name || "—",
            Age: fullPat.age || "—",
            Gender: fullPat.gender || "—",
            Phone: fullPat.mobile || "—",
            "Doctor Name": v.doctor || doctor?.name || "—",
            Service: v.service || "—",
            "Diagnosis / Notes": v.notes || "—",
            Medicines: medicines || "—",
            "Amount (Rs.)": v.amount || "0",
          });
        }
      }
      if (rows.length === 0) {
        showNotify(
          "No Patients",
          "No patients visited on " + fmtDateShort(reportDate) + ".",
          true,
        );
        setExporting(false);
        return;
      }
      const XLSX = window.XLSX;
      const ws = XLSX.utils.json_to_sheet(rows);
      ws["!cols"] = [
        { wch: 6 },
        { wch: 14 },
        { wch: 10 },
        { wch: 22 },
        { wch: 6 },
        { wch: 8 },
        { wch: 14 },
        { wch: 20 },
        { wch: 24 },
        { wch: 36 },
        { wch: 48 },
        { wch: 12 },
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        ws,
        "Patients_" + reportDate.replace(/-/g, ""),
      );
      const summaryData = [
        { Report: "Daily Patient Report" },
        { Report: "Hospital: " + (hospital?.name || "—") },
        { Report: "Date: " + fmtDateShort(reportDate) },
        { Report: "Total Patients: " + rows.length },
        {
          Report:
            "Total Revenue: Rs. " +
            rows
              .reduce(
                (s, r) =>
                  s +
                  parseFloat(
                    (r["Amount (Rs.)"] || "0")
                      .toString()
                      .replace(/[^0-9.]/g, "") || 0,
                  ),
                0,
              )
              .toLocaleString("en-IN"),
        },
        { Report: "Generated: " + new Date().toLocaleString("en-IN") },
      ];
      const wsSummary = XLSX.utils.json_to_sheet(summaryData);
      wsSummary["!cols"] = [{ wch: 50 }];
      XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
      const fileName =
        (hospital?.name || "Hospital").replace(/\s+/g, "_") +
        "_Daily_Report_" +
        reportDate +
        ".xlsx";
      XLSX.writeFile(wb, fileName);
      showNotify(
        "✅ Report Downloaded!",
        rows.length +
          " patient" +
          (rows.length !== 1 ? "s" : "") +
          " on " +
          fmtDateShort(reportDate) +
          ". File: " +
          fileName,
      );
    } catch (err) {
      showNotify("Error", "Failed to export: " + err.message, true);
    }
    setExporting(false);
  };

  // ── LIST VIEW ─────────────────────────────────────────────────
  if (!selectedPatient) {
    return (
      <div>
        <div className="admin-section-title">Patient Profiles</div>
        <div className="admin-section-desc">
          Create and manage individual patient profiles. Click a profile to view
          visit history and add new records.
        </div>

        {/* ✅ NEW — Daily Report Export Bar */}
        <div
          style={{
            background: "linear-gradient(135deg,#0a1628,#0d2444)",
            borderRadius: 14,
            padding: "16px 20px",
            marginBottom: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#fff",
                marginBottom: 3,
              }}
            >
              📊 Daily Patient Report
            </div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>
              Export all patients who visited on a selected date as Excel
              (.xlsx)
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <input
              type="date"
              value={reportDate}
              onChange={(e) => setReportDate(e.target.value)}
              style={{
                fontSize: 13,
                padding: "7px 12px",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 8,
                background: "rgba(255,255,255,0.08)",
                color: "#fff",
                fontFamily: "DM Sans,sans-serif",
                cursor: "pointer",
              }}
            />
            <button
              onClick={exportDailyReport}
              disabled={exporting}
              style={{
                padding: "8px 18px",
                background: exporting
                  ? "#475569"
                  : "linear-gradient(135deg,#0d7377,#14a0a5)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 700,
                cursor: exporting ? "not-allowed" : "pointer",
                fontFamily: "DM Sans,sans-serif",
                whiteSpace: "nowrap",
              }}
            >
              {exporting ? "⏳ Exporting..." : "⬇️ Export Excel"}
            </button>
          </div>
        </div>

        <div className="patients-list-view">
          <input
            type="text"
            className="patient-search-bar"
            placeholder="🔍 Search patients by name or phone..."
            onChange={(e) => filterPatients(e.target.value)}
          />
          {showNewForm && (
            <div className="new-patient-form">
              <h4>➕ Create New Patient Profile</h4>
              <div className="new-patient-grid">
                {[
                  ["name", "text", "Full Name *", "Patient full name"],
                  ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
                  ["email", "email", "Email Address", "patient@email.com"],
                  ["age", "number", "Age", "Age"],
                ].map(([k, t, label, ph]) => (
                  <div key={k}>
                    <div className="admin-row-label">{label}</div>
                    <input
                      type={t}
                      placeholder={ph}
                      value={newPat[k]}
                      onChange={(e) =>
                        setNewPat((p) => ({ ...p, [k]: e.target.value }))
                      }
                    />
                  </div>
                ))}
                <div>
                  <div className="admin-row-label">Gender</div>
                  <select
                    value={newPat.gender}
                    onChange={(e) =>
                      setNewPat((p) => ({ ...p, gender: e.target.value }))
                    }
                  >
                    <option value="">Select Gender</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </select>
                </div>
                <div>
                  <div className="admin-row-label">Blood Group</div>
                  <input
                    type="text"
                    placeholder="e.g. B+"
                    value={newPat.blood}
                    onChange={(e) =>
                      setNewPat((p) => ({ ...p, blood: e.target.value }))
                    }
                  />
                </div>
              </div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <button className="add-visit-save-btn" onClick={createPatient}>
                  💾 Save Patient Profile
                </button>
                <button
                  className="btn-back-patients"
                  onClick={() => setShowNewForm(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 14,
              flexWrap: "wrap",
              gap: 10,
            }}
          >
            <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
              {loading
                ? "Loading patients..."
                : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
            </div>
            <button
              className="admin-add-btn"
              onClick={() => setShowNewForm((s) => !s)}
            >
              {showNewForm ? "Cancel" : "+ New Patient Profile"}
            </button>
          </div>
          <div className="patient-profiles-grid">
            {loading ? (
              <div
                style={{
                  color: "var(--gray-400)",
                  fontSize: 14,
                  padding: "20px 0",
                  gridColumn: "1/-1",
                }}
              >
                Loading...
              </div>
            ) : filtered.length === 0 ? (
              <div
                style={{
                  color: "var(--gray-400)",
                  fontSize: 14,
                  padding: "24px 0",
                  gridColumn: "1/-1",
                  textAlign: "center",
                }}
              >
                No patients yet. Click "+ New Patient Profile" to add your first
                patient.
              </div>
            ) : (
              filtered.map((p) => (
                <div
                  key={p._id}
                  className="patient-profile-card"
                  onClick={() => openPatient(p)}
                >
                  <div className="patient-avatar-icon">🧑‍⚕️</div>
                  <div className="patient-card-name">{p.name}</div>
                  <div className="patient-card-id">📞 {p.mobile || "—"}</div>
                  <div className="patient-card-visits">
                    📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    );
  }

  // ── DETAIL VIEW ───────────────────────────────────────────────
  const p = selectedPatient;
  const visits = p.visits || [];
  const total = totalRevenue(visits);

  return (
    <div>
      <div className="patient-detail-view open">
        <div className="patient-detail-header">
          <button
            className="btn-back-patients"
            onClick={() => setSelectedPatient(null)}
          >
            ← Back to Patients
          </button>
          <div
            className="patient-avatar-icon"
            style={{ width: 56, height: 56, fontSize: 26 }}
          >
            🧑‍⚕️
          </div>
          <div style={{ flex: 1 }}>
            <h3>{p.name}</h3>
            <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
              {p.email}
              {p.email && p.mobile ? " · " : ""}
              {p.mobile}
            </p>
            <div className="patient-info-row">
              {[
                p.age ? "Age: " + p.age : null,
                p.gender || null,
                p.blood ? "Blood: " + p.blood : null,
              ]
                .filter(Boolean)
                .map((t, i) => (
                  <span key={i} className="patient-info-pill">
                    {t}
                  </span>
                ))}
            </div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div
              style={{
                fontSize: 11,
                color: "var(--gray-400)",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                marginBottom: 4,
              }}
            >
              Total Revenue
            </div>
            <div
              style={{
                fontFamily: "Cormorant Garamond,serif",
                fontSize: 26,
                fontWeight: 600,
                color: "var(--teal)",
                lineHeight: 1,
              }}
            >
              Rs. {total.toLocaleString("en-IN")}
            </div>
            <div
              style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
            >
              {visits.length} visit{visits.length !== 1 ? "s" : ""}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              alignSelf: "flex-start",
              marginTop: 4,
            }}
          >
            <button className="admin-del-btn" onClick={deletePatient}>
              🗑️ Delete Profile
            </button>
          </div>
        </div>

        {/* Add Visit Form */}
        <div className="add-visit-form">
          <h4>📋 Add New Visit Record</h4>
          <div className="add-visit-grid">
            <div>
              <div className="admin-row-label">Visit Date *</div>
              <input
                type="date"
                value={visitForm.date}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, date: e.target.value }))
                }
              />
            </div>
            <div>
              <div className="admin-row-label">Visit Time</div>
              <input
                type="time"
                value={visitForm.time}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, time: e.target.value }))
                }
              />
            </div>
            <div>
              <div className="admin-row-label">Service Taken *</div>
              <select
                value={visitForm.service}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, service: e.target.value }))
                }
              >
                <option value="">Select Service</option>
                {servicesList.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <div className="admin-row-label">Amount Charged (Rs.)</div>
              <input
                type="text"
                placeholder="e.g. 2500"
                value={visitForm.amount}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, amount: e.target.value }))
                }
              />
            </div>
            <div>
              <div
                className="admin-row-label"
                style={{ display: "flex", alignItems: "center", gap: 6 }}
              >
                Next Date to Visit
                <span
                  style={{
                    fontSize: 10,
                    color: "var(--teal)",
                    fontWeight: 400,
                    background: "rgba(13,115,119,0.08)",
                    padding: "2px 8px",
                    borderRadius: 100,
                    border: "1px solid rgba(13,115,119,0.2)",
                  }}
                >
                  For follow-up
                </span>
              </div>
              <input
                type="date"
                value={visitForm.nextVisitDate}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
                }
                style={{ marginTop: 6 }}
              />
            </div>
          </div>

          <style>{`
            @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
            @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
          `}</style>
          <div
            className="admin-row-label"
            style={{ marginBottom: 6, marginTop: 8 }}
          >
            💊 Prescription
          </div>

          {/* DESKTOP TABLE */}
          <div
            className="rx-table-desktop"
            style={{
              overflowX: "auto",
              marginBottom: 8,
              position: "relative",
              zIndex: 1000,
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: 13,
                fontFamily: "'DM Sans',sans-serif",
                minWidth: 560,
              }}
            >
              <thead>
                <tr
                  style={{
                    background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
                    color: "#fff",
                  }}
                >
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                      width: 36,
                    }}
                  >
                    SR.
                  </th>
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  >
                    MEDICINE
                  </th>
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  >
                    DOSAGE INSTRUCTION
                  </th>
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                      width: 95,
                    }}
                  >
                    DURATION
                  </th>
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                      width: 95,
                    }}
                  >
                    ROUTE
                  </th>
                  <th style={{ padding: "8px 10px", width: 32 }}></th>
                </tr>
              </thead>
              <tbody>
                {visitForm.rxRows.map((row, idx) => (
                  <tr
                    key={idx}
                    style={{
                      background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
                      borderBottom: "1px solid #e8e4e0",
                    }}
                  >
                    <td
                      style={{
                        padding: "6px 10px",
                        color: "#666",
                        fontSize: 12,
                        textAlign: "center",
                      }}
                    >
                      {idx + 1}
                    </td>
                    <td style={{ padding: "4px 6px" }}>
                      <RxMedInput
                        value={row.medicine}
                        onChange={(v) => {
                          const rows = [...visitForm.rxRows];
                          rows[idx] = { ...rows[idx], medicine: v };
                          setVisitForm((f) => ({ ...f, rxRows: rows }));
                        }}
                        customMeds={customMeds}
                        onCustomSaved={(saved) => {
                          if (saved && saved._id) {
                            setCustomMeds((prev) => {
                              const exists = prev.some(
                                (m) =>
                                  m._id === saved._id ||
                                  m.name.toLowerCase() ===
                                    saved.name.toLowerCase(),
                              );
                              if (exists) return prev;
                              return [saved, ...prev];
                            });
                          } else {
                            api
                              .get("/custommeds")
                              .then((data) => {
                                if (Array.isArray(data)) setCustomMeds(data);
                              })
                              .catch(() => {});
                          }
                        }}
                      />
                    </td>
                    <td style={{ padding: "4px 6px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          flexWrap: "nowrap",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          {["M", "A", "N"].map((label, li) => (
                            <div
                              key={label}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 9,
                                  color: "#888",
                                  marginBottom: 1,
                                }}
                              >
                                {label}
                              </span>
                              <input
                                type="text"
                                maxLength={2}
                                value={
                                  (row.dosageParts || ["0", "0", "0"])[li] ||
                                  "0"
                                }
                                onFocus={(e) => {
                                  if (e.target.value === "0") e.target.select();
                                }}
                                onChange={(e) => {
                                  const rows = [...visitForm.rxRows];
                                  const parts = [
                                    ...(rows[idx].dosageParts || [
                                      "0",
                                      "0",
                                      "0",
                                    ]),
                                  ];
                                  parts[li] =
                                    e.target.value === ""
                                      ? "0"
                                      : e.target.value;
                                  rows[idx] = {
                                    ...rows[idx],
                                    dosageParts: parts,
                                    dosage:
                                      parts.join("-") +
                                      (rows[idx].dosageTiming
                                        ? " " + rows[idx].dosageTiming
                                        : ""),
                                  };
                                  setVisitForm((f) => ({ ...f, rxRows: rows }));
                                }}
                                style={{
                                  width: 28,
                                  border: "1px solid #ddd",
                                  borderRadius: 4,
                                  padding: "4px 3px",
                                  fontSize: 12,
                                  textAlign: "center",
                                  fontFamily: "'DM Sans',sans-serif",
                                }}
                              />
                            </div>
                          ))}
                        </div>
                        <select
                          value={row.dosageTiming || "after meal"}
                          onChange={(e) => {
                            const rows = [...visitForm.rxRows];
                            const parts = rows[idx].dosageParts || [
                              "0",
                              "0",
                              "0",
                            ];
                            rows[idx] = {
                              ...rows[idx],
                              dosageTiming: e.target.value,
                              dosage: parts.join("-") + " " + e.target.value,
                            };
                            setVisitForm((f) => ({ ...f, rxRows: rows }));
                          }}
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: 4,
                            padding: "4px 5px",
                            fontSize: 11,
                            fontFamily: "'DM Sans',sans-serif",
                            color: "#444",
                          }}
                        >
                          <option>after meal</option>
                          <option>before meal</option>
                          <option>with meal</option>
                          <option>empty stomach</option>
                          <option>at bedtime</option>
                          <option>as directed</option>
                        </select>
                      </div>
                    </td>
                    <td style={{ padding: "4px 6px" }}>
                      <input
                        type="text"
                        placeholder="e.g. 7 days"
                        value={row.duration}
                        onChange={(e) => {
                          const rows = [...visitForm.rxRows];
                          rows[idx] = {
                            ...rows[idx],
                            duration: e.target.value,
                          };
                          setVisitForm((f) => ({ ...f, rxRows: rows }));
                        }}
                        style={{
                          width: "100%",
                          border: "1px solid #ddd",
                          borderRadius: 5,
                          padding: "5px 8px",
                          fontSize: 12,
                          fontFamily: "'DM Sans',sans-serif",
                        }}
                      />
                    </td>
                    <td style={{ padding: "4px 6px" }}>
                      <select
                        value={row.route}
                        onChange={(e) => {
                          const rows = [...visitForm.rxRows];
                          rows[idx] = { ...rows[idx], route: e.target.value };
                          setVisitForm((f) => ({ ...f, rxRows: rows }));
                        }}
                        style={{
                          width: "100%",
                          border: "1px solid #ddd",
                          borderRadius: 5,
                          padding: "5px 6px",
                          fontSize: 12,
                          fontFamily: "'DM Sans',sans-serif",
                        }}
                      >
                        <option>ORAL</option>
                        <option>TOPICAL</option>
                        <option>INJECTION</option>
                        <option>INHALER</option>
                        <option>DROPS</option>
                        <option>GARGLE</option>
                        <option>OTHER</option>
                      </select>
                    </td>
                    <td style={{ padding: "4px 6px", textAlign: "center" }}>
                      {visitForm.rxRows.length > 1 && (
                        <button
                          onClick={() => {
                            const rows = visitForm.rxRows.filter(
                              (_, i) => i !== idx,
                            );
                            setVisitForm((f) => ({ ...f, rxRows: rows }));
                          }}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#e74c3c",
                            fontSize: 16,
                            cursor: "pointer",
                            padding: "2px 6px",
                          }}
                        >
                          ✕
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* MOBILE CARDS */}
          <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
            {visitForm.rxRows.map((row, idx) => (
              <div
                key={idx}
                style={{
                  background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
                  border: "1px solid #e8e4e0",
                  borderRadius: 8,
                  padding: "10px 12px",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#0a1628",
                      background: "rgba(10,22,40,0.08)",
                      padding: "2px 8px",
                      borderRadius: 20,
                    }}
                  >
                    #{idx + 1}
                  </span>
                  {visitForm.rxRows.length > 1 && (
                    <button
                      onClick={() => {
                        const rows = visitForm.rxRows.filter(
                          (_, i) => i !== idx,
                        );
                        setVisitForm((f) => ({ ...f, rxRows: rows }));
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#e74c3c",
                        fontSize: 16,
                        cursor: "pointer",
                        padding: "2px 6px",
                      }}
                    >
                      ✕
                    </button>
                  )}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#888",
                      fontWeight: 600,
                      marginBottom: 3,
                      textTransform: "uppercase",
                    }}
                  >
                    Medicine
                  </div>
                  <RxMedInput
                    value={row.medicine}
                    onChange={(v) => {
                      const rows = [...visitForm.rxRows];
                      rows[idx] = { ...rows[idx], medicine: v };
                      setVisitForm((f) => ({ ...f, rxRows: rows }));
                    }}
                    customMeds={customMeds}
                    onCustomSaved={(saved) => {
                      if (saved && saved._id) {
                        setCustomMeds((prev) => {
                          const exists = prev.some(
                            (m) =>
                              m._id === saved._id ||
                              m.name.toLowerCase() === saved.name.toLowerCase(),
                          );
                          if (exists) return prev;
                          return [saved, ...prev];
                        });
                      } else {
                        api
                          .get("/custommeds")
                          .then((data) => {
                            if (Array.isArray(data)) setCustomMeds(data);
                          })
                          .catch(() => {});
                      }
                    }}
                  />
                </div>
                <div style={{ marginBottom: 8 }}>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#888",
                      fontWeight: 600,
                      marginBottom: 3,
                      textTransform: "uppercase",
                    }}
                  >
                    Dosage Instruction
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      {["M", "A", "N"].map((label, li) => (
                        <div
                          key={label}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              fontSize: 9,
                              color: "#888",
                              marginBottom: 1,
                            }}
                          >
                            {label}
                          </span>
                          <input
                            type="text"
                            maxLength={2}
                            value={
                              (row.dosageParts || ["0", "0", "0"])[li] || "0"
                            }
                            onFocus={(e) => {
                              if (e.target.value === "0") e.target.select();
                            }}
                            onChange={(e) => {
                              const rows = [...visitForm.rxRows];
                              const parts = [
                                ...(rows[idx].dosageParts || ["0", "0", "0"]),
                              ];
                              parts[li] =
                                e.target.value === "" ? "0" : e.target.value;
                              rows[idx] = {
                                ...rows[idx],
                                dosageParts: parts,
                                dosage:
                                  parts.join("-") +
                                  (rows[idx].dosageTiming
                                    ? " " + rows[idx].dosageTiming
                                    : ""),
                              };
                              setVisitForm((f) => ({ ...f, rxRows: rows }));
                            }}
                            style={{
                              width: 34,
                              border: "1px solid #ddd",
                              borderRadius: 4,
                              padding: "5px 3px",
                              fontSize: 13,
                              textAlign: "center",
                              fontFamily: "'DM Sans',sans-serif",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                    <select
                      value={row.dosageTiming || "after meal"}
                      onChange={(e) => {
                        const rows = [...visitForm.rxRows];
                        const parts = rows[idx].dosageParts || ["0", "0", "0"];
                        rows[idx] = {
                          ...rows[idx],
                          dosageTiming: e.target.value,
                          dosage: parts.join("-") + " " + e.target.value,
                        };
                        setVisitForm((f) => ({ ...f, rxRows: rows }));
                      }}
                      style={{
                        flex: 1,
                        border: "1px solid #ddd",
                        borderRadius: 4,
                        padding: "5px 6px",
                        fontSize: 12,
                        fontFamily: "'DM Sans',sans-serif",
                        color: "#444",
                        minWidth: 120,
                      }}
                    >
                      <option>after meal</option>
                      <option>before meal</option>
                      <option>with meal</option>
                      <option>empty stomach</option>
                      <option>at bedtime</option>
                      <option>as directed</option>
                    </select>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: 10,
                        color: "#888",
                        fontWeight: 600,
                        marginBottom: 3,
                        textTransform: "uppercase",
                      }}
                    >
                      Duration
                    </div>
                    <input
                      type="text"
                      placeholder="e.g. 7 days"
                      value={row.duration}
                      onChange={(e) => {
                        const rows = [...visitForm.rxRows];
                        rows[idx] = { ...rows[idx], duration: e.target.value };
                        setVisitForm((f) => ({ ...f, rxRows: rows }));
                      }}
                      style={{
                        width: "100%",
                        border: "1px solid #ddd",
                        borderRadius: 5,
                        padding: "6px 8px",
                        fontSize: 12,
                        fontFamily: "'DM Sans',sans-serif",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: 10,
                        color: "#888",
                        fontWeight: 600,
                        marginBottom: 3,
                        textTransform: "uppercase",
                      }}
                    >
                      Route
                    </div>
                    <select
                      value={row.route}
                      onChange={(e) => {
                        const rows = [...visitForm.rxRows];
                        rows[idx] = { ...rows[idx], route: e.target.value };
                        setVisitForm((f) => ({ ...f, rxRows: rows }));
                      }}
                      style={{
                        width: "100%",
                        border: "1px solid #ddd",
                        borderRadius: 5,
                        padding: "6px 6px",
                        fontSize: 12,
                        fontFamily: "'DM Sans',sans-serif",
                      }}
                    >
                      <option>ORAL</option>
                      <option>TOPICAL</option>
                      <option>INJECTION</option>
                      <option>INHALER</option>
                      <option>DROPS</option>
                      <option>GARGLE</option>
                      <option>OTHER</option>
                    </select>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() =>
              setVisitForm((f) => ({
                ...f,
                rxRows: [
                  ...f.rxRows,
                  {
                    medicine: "",
                    dosageParts: ["0", "0", "0"],
                    dosageTiming: "after meal",
                    dosage: "",
                    duration: "",
                    route: "ORAL",
                  },
                ],
              }))
            }
            style={{
              marginTop: 4,
              marginBottom: 8,
              background: "rgba(13,115,119,0.08)",
              border: "1px solid rgba(13,115,119,0.3)",
              color: "var(--teal)",
              borderRadius: 7,
              padding: "6px 16px",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            + Add Medicine
          </button>

          <div
            className="admin-row-label"
            style={{ marginBottom: 6, marginTop: 10 }}
          >
            Doctor Notes / Diagnosis
          </div>
          <MedAutocomplete
            value={visitForm.notes}
            onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
            customMeds={customMeds}
            apiPost={api.post}
            onCustomSaved={(saved) => {
              if (saved && saved._id) {
                setCustomMeds((prev) => {
                  const exists = prev.some(
                    (m) =>
                      m._id === saved._id ||
                      m.name.toLowerCase() === saved.name.toLowerCase(),
                  );
                  if (exists) return prev;
                  return [saved, ...prev];
                });
              } else {
                api
                  .get("/custommeds")
                  .then((data) => {
                    if (Array.isArray(data)) setCustomMeds(data);
                  })
                  .catch(() => {});
              }
            }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 10,
              marginTop: 4,
            }}
          >
            <button className="add-visit-save-btn" onClick={saveVisit}>
              💾 Save Visit Record
            </button>
          </div>
        </div>

        {/* Visit History */}
        <div style={{ marginBottom: 12 }}>
          <div className="admin-section-title" style={{ marginBottom: 8 }}>
            Visit History
          </div>
          <div className="visit-records-list">
            {visits.length === 0 ? (
              <div
                style={{
                  color: "var(--gray-400)",
                  fontSize: 13,
                  padding: "10px 0",
                }}
              >
                No visits recorded yet. Add the first visit above.
              </div>
            ) : (
              visits.map((v, i) => {
                const dtStr =
                  (v.visitDate || "") +
                  (v.visitTime ? " at " + v.visitTime : "");
                const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
                return (
                  <div key={v._id || i} className="visit-record-card">
                    <button
                      className="visit-del-btn"
                      onClick={() => deleteVisit(v._id)}
                      title="Delete"
                    >
                      ✕
                    </button>
                    <div className="visit-record-meta">
                      <span className="visit-record-service">
                        {v.service || "Visit"}
                      </span>
                      <span className="visit-record-date">📅 {dtStr}</span>
                      {v.amount && (
                        <span
                          className="patient-info-pill"
                          style={{ fontSize: 11 }}
                        >
                          Rs. {v.amount}
                        </span>
                      )}
                      {v.doctor && (
                        <span
                          style={{
                            fontSize: 11,
                            color: "var(--teal)",
                            fontWeight: 600,
                            background: "rgba(13,115,119,0.08)",
                            padding: "2px 8px",
                            borderRadius: 100,
                            border: "1px solid rgba(13,115,119,0.2)",
                          }}
                        >
                          👨‍⚕️ {v.doctor}
                        </span>
                      )}
                    </div>
                    <div className="visit-record-notes">{v.notes || "—"}</div>
                    {v.prescription &&
                      v.prescription.medicineRows &&
                      v.prescription.medicineRows.length > 0 && (
                        <div style={{ marginTop: 10, overflowX: "auto" }}>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              fontSize: 12,
                              fontFamily: "'DM Sans',sans-serif",
                            }}
                          >
                            <thead>
                              <tr
                                style={{
                                  background:
                                    "linear-gradient(135deg,#0a1628,#1a3a6b)",
                                  color: "#fff",
                                }}
                              >
                                <th
                                  style={{
                                    padding: "6px 8px",
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontSize: 11,
                                    width: 30,
                                  }}
                                >
                                  SR.
                                </th>
                                <th
                                  style={{
                                    padding: "6px 8px",
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontSize: 11,
                                  }}
                                >
                                  MEDICINE
                                </th>
                                <th
                                  style={{
                                    padding: "6px 8px",
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontSize: 11,
                                  }}
                                >
                                  DOSAGE INSTRUCTION
                                </th>
                                <th
                                  style={{
                                    padding: "6px 8px",
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontSize: 11,
                                    width: 90,
                                  }}
                                >
                                  DUR. / ROUTE
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {v.prescription.medicineRows.map((row, ri) => (
                                <tr
                                  key={ri}
                                  style={{
                                    background:
                                      ri % 2 === 0 ? "#f8f9fc" : "#fff",
                                    borderBottom: "1px solid #e8e4e0",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "5px 8px",
                                      color: "#666",
                                      fontSize: 11,
                                      textAlign: "center",
                                    }}
                                  >
                                    {ri + 1}.
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px 8px",
                                      fontWeight: 600,
                                      color: "#0a1628",
                                    }}
                                  >
                                    {row.medicine || "—"}
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px 8px",
                                      color: "#444",
                                    }}
                                  >
                                    {row.dosage || "—"}
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px 8px",
                                      color: "#666",
                                      fontSize: 11,
                                    }}
                                  >
                                    {row.duration}
                                    {row.duration && row.route ? " / " : ""}
                                    {row.route}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    {v.nextVisitDate && (
                      <div
                        style={{
                          marginTop: 8,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          background: isFollowUp
                            ? "rgba(201,168,76,0.12)"
                            : "rgba(13,115,119,0.08)",
                          border:
                            "1px solid " +
                            (isFollowUp
                              ? "rgba(201,168,76,0.35)"
                              : "rgba(13,115,119,0.2)"),
                          borderRadius: 100,
                          padding: "3px 12px",
                          fontSize: 12,
                          fontWeight: 500,
                          color: isFollowUp ? "#8b6914" : "var(--teal)",
                        }}
                      >
                        {isFollowUp ? "Follow-Up: " : "Next Visit: "}
                        {fmtDateShort(v.nextVisitDate)}
                        {isFollowUp ? " — WhatsApp sent" : ""}
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        marginTop: 10,
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        onClick={() => sendPrescription(v)}
                        style={{
                          background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
                          color: "white",
                          border: "none",
                          borderRadius: 7,
                          padding: "7px 14px",
                          fontSize: 12,
                          fontWeight: 500,
                          cursor: "pointer",
                          fontFamily: "'DM Sans',sans-serif",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          transition: "opacity 0.2s",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.opacity = "0.85")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.opacity = "1")
                        }
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
                        </svg>
                        Send Prescription
                      </button>
                      <button
                        onClick={() => {
                          let mob = (p.mobile || "").replace(
                            /[\s\-\(\)\+]/g,
                            "",
                          );
                          if (!mob) {
                            alert("No mobile number saved for this patient.");
                            return;
                          }
                          if (!mob.startsWith("91") && mob.length === 10)
                            mob = "91" + mob;
                          const msg = encodeURIComponent(
                            ` *Welcome to ${hospital.name}!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family.\n\n_Wishing you great health!_\n— *${hospital.name} Team*`,
                          );
                          window.open(
                            "https://wa.me/" + mob + "?text=" + msg,
                            "_blank",
                          );
                        }}
                        style={{
                          background: "linear-gradient(135deg,#25d366,#128c7e)",
                          color: "white",
                          border: "none",
                          borderRadius: 7,
                          padding: "7px 14px",
                          fontSize: 12,
                          fontWeight: 500,
                          cursor: "pointer",
                          fontFamily: "'DM Sans',sans-serif",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          transition: "opacity 0.2s",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.opacity = "0.85")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.opacity = "1")
                        }
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
                        </svg>
                        Patient Number
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* ✅ NEW — Patient Lab Reports Section */}
        <div style={{ marginBottom: 28 }}>
          <div className="admin-section-title" style={{ marginBottom: 4 }}>
            🧪 Patient Lab Reports
          </div>
          <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
            Upload or link lab reports for <strong>{p.name}</strong>. Stored
            permanently. Only visible to this hospital.
          </div>

          {/* Add Report Form */}
          <div
            style={{
              background: "#f8fafc",
              border: "1.5px solid #e2e8f0",
              borderRadius: 14,
              padding: 18,
              marginBottom: 20,
            }}
          >
            <div style={{ marginBottom: 12 }}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#374151",
                  marginBottom: 5,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                }}
              >
                Report Name *
              </div>
              <input
                type="text"
                placeholder="e.g. Blood Test, OPG X-Ray, CBC Report, HbA1c"
                value={labName}
                onChange={(e) => setLabName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") saveLabReport();
                }}
                style={{
                  width: "100%",
                  padding: "10px 13px",
                  borderRadius: 8,
                  border: "1.5px solid #e2e8f0",
                  fontSize: 13,
                  fontFamily: "DM Sans,sans-serif",
                  outline: "none",
                  background: "#fff",
                  boxSizing: "border-box",
                }}
              />
            </div>
            <div style={{ marginBottom: 14 }}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#374151",
                  marginBottom: 5,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                }}
              >
                Attach File or Paste URL *
              </div>
              {/* Upload Button */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 8,
                  flexWrap: "wrap",
                }}
              >
                <label
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 7,
                    padding: "9px 18px",
                    background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
                    color: "#fff",
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: "pointer",
                    fontFamily: "DM Sans,sans-serif",
                    whiteSpace: "nowrap",
                  }}
                >
                  {labUploading ? "⏳ Reading..." : "📎 Upload File"}
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (!file) return;
                      if (!labName.trim())
                        setLabName(file.name.replace(/\.[^/.]+$/, ""));
                      setLabUploading(true);
                      setLabUrl("");
                      const reader = new FileReader();
                      reader.onload = (ev) => {
                        setLabUrl(ev.target.result);
                        setLabUploading(false);
                      };
                      reader.onerror = () => {
                        showNotify("Error", "Could not read file.", true);
                        setLabUploading(false);
                      };
                      reader.readAsDataURL(file);
                    }}
                  />
                </label>
                <span
                  style={{
                    fontSize: 12,
                    color: "#94a3b8",
                    fontStyle: "italic",
                  }}
                >
                  or paste a public link below
                </span>
              </div>
              {/* URL Input — hidden when file loaded */}
              {!labUrl.startsWith("data:") && (
                <input
                  type="url"
                  placeholder="https://drive.google.com/file/d/...  or  https://cloudinary.com/..."
                  value={labUrl}
                  onChange={(e) => setLabUrl(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") saveLabReport();
                  }}
                  style={{
                    width: "100%",
                    padding: "10px 13px",
                    borderRadius: 8,
                    border: "1.5px solid #e2e8f0",
                    fontSize: 13,
                    fontFamily: "DM Sans,sans-serif",
                    outline: "none",
                    background: "#fff",
                    boxSizing: "border-box",
                  }}
                />
              )}
              {/* File loaded confirmation strip */}
              {labUrl.startsWith("data:") && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    background: "#f0fdf4",
                    border: "1.5px solid #86efac",
                    borderRadius: 8,
                    padding: "9px 14px",
                  }}
                >
                  <span style={{ fontSize: 20 }}>
                    {labUrl.startsWith("data:image") ? "🖼️" : "📄"}
                  </span>
                  <span
                    style={{
                      fontSize: 13,
                      color: "#16a34a",
                      fontWeight: 600,
                      flex: 1,
                    }}
                  >
                    File loaded — ready to save
                  </span>
                  <button
                    onClick={() => setLabUrl("")}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#dc2626",
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 700,
                      padding: "2px 6px",
                    }}
                  >
                    ✕ Remove
                  </button>
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={saveLabReport}
                disabled={labSaving || labUploading}
                style={{
                  padding: "10px 24px",
                  background:
                    labSaving || labUploading
                      ? "#94a3b8"
                      : "linear-gradient(135deg,#0d7377,#14a0a5)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: labSaving || labUploading ? "not-allowed" : "pointer",
                  fontFamily: "DM Sans,sans-serif",
                }}
              >
                {labSaving
                  ? "Saving..."
                  : labUploading
                    ? "Loading file..."
                    : "💾 Save Report"}
              </button>
              <span style={{ fontSize: 11, color: "#94a3b8" }}>
                💡 Supports PDF, images, Word, Excel. For large files use Google
                Drive / Cloudinary link.
              </span>
            </div>
          </div>

          {/* Reports List */}
          {labReports.length === 0 ? (
            <div style={{ color: "#94a3b8", fontSize: 13, padding: "8px 0" }}>
              No lab reports saved yet for {p.name}. Add the first report above.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {labReports.map((report, i) => (
                <div
                  key={report._id || i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    background: "#fff",
                    border: "1.5px solid #e2e8f0",
                    borderRadius: 12,
                    padding: "13px 16px",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  {/* Icon */}
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      background: "rgba(13,115,119,0.08)",
                      borderRadius: 10,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 22,
                      flexShrink: 0,
                    }}
                  >
                    {(report.url || "").startsWith("data:image") ? "🖼️" : "🧪"}
                  </div>
                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: 14,
                        color: "#0a1628",
                        marginBottom: 3,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {report.name}
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: "#94a3b8",
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <span>🕐</span>
                      <span>{fmtUploadedAt(report.uploadedAt)}</span>
                    </div>
                  </div>
                  {/* View Button — handles both data: URLs and https:// URLs */}
                  <button
                    onClick={() => {
                      const url = report.url || "";
                      if (url.startsWith("data:")) {
                        // Convert base64 data URL → blob URL so browser can open it in new tab
                        try {
                          const [meta, base64] = url.split(",");
                          const mime = meta.match(/:(.*?);/)[1];
                          const bytes = atob(base64);
                          const arr = new Uint8Array(bytes.length);
                          for (let i = 0; i < bytes.length; i++)
                            arr[i] = bytes.charCodeAt(i);
                          const blob = new Blob([arr], { type: mime });
                          const blobUrl = URL.createObjectURL(blob);
                          const win = window.open(blobUrl, "_blank");
                          // Revoke after 60s to free memory
                          setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
                          if (!win)
                            alert(
                              "Popup blocked. Please allow popups for this site.",
                            );
                        } catch (e) {
                          alert(
                            "Could not open file. Try downloading instead.",
                          );
                        }
                      } else {
                        window.open(url, "_blank");
                      }
                    }}
                    style={{
                      padding: "8px 14px",
                      background: "rgba(13,115,119,0.08)",
                      color: "#0d7377",
                      border: "1.5px solid rgba(13,115,119,0.2)",
                      borderRadius: 8,
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                    }}
                  >
                    🔗 View
                  </button>
                  {/* Delete Button */}
                  <button
                    onClick={() => deleteLabReport(report._id)}
                    style={{
                      padding: "8px 12px",
                      background: "#fef2f2",
                      color: "#dc2626",
                      border: "1.5px solid #fca5a5",
                      borderRadius: 8,
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                    }}
                  >
                    🗑️ Delete
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {rxModal && (
        <PrescriptionModal
          visit={rxModal.visit}
          patient={rxModal.patient}
          doctor={rxModal.doctor}
          hospital={hospital}
          onClose={() => setRxModal(null)}
          showNotify={showNotify}
        />
      )}
    </div>
  );
}

// ── Medicine Database (local ~150 dental medicines) ──────────
const MEDICINE_DB = [
  { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
  { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
  { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
  { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
  { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
  { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
  { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
  { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
  { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
  { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
  { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
  { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
  { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
  { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
  { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
  { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
  { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
  { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
  { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
  { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
  { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
  { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
  { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
  { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
  { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
  { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
  { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
  { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
  { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
  { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
  { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
  { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
  { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
  { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
  { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
  { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
  { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
  { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
  { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
  { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
  { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
  { name: "Naproxen 250mg Tablet", cat: "NSAID" },
  { name: "Naproxen 500mg Tablet", cat: "NSAID" },
  { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
  { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
  { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
  { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
  { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
  { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
  { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
  { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
  { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
  { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
  {
    name: "Lignocaine + Adrenaline 2% Dental Cartridge",
    cat: "Local Anaesthetic",
  },
  {
    name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
    cat: "Local Anaesthetic",
  },
  {
    name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
    cat: "Local Anaesthetic",
  },
  { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
  { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
  { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
  { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
  { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
  {
    name: "EMLA Cream (Lignocaine + Prilocaine)",
    cat: "Local Anaesthetic Topical",
  },
  { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
  { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
  { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
  { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
  { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
  { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
  { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
  { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
  { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
  { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
  { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
  { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
  { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
  { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
  { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
  { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
  { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
  { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
  { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
  { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
  { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
  { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
  { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
  { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
  { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
  { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
  { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
  { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
  { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
  { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
  { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
  {
    name: "Benzydamine Hydrochloride 0.15% Mouthwash",
    cat: "Dental Analgesic Rinse",
  },
  { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
  { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
  { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
  { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
  { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
  { name: "Composite Resin A2 Shade", cat: "Dental Material" },
  { name: "Composite Resin A3 Shade", cat: "Dental Material" },
  { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
  { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
  { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
  { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
  { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
  { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
  { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
  { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
  { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
  { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
  { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
  { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
  { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
  { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
  { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
  { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
  { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
  { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
  { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
  { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
  { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
  { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
  { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
  { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
  { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
  { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
  { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
  { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
  { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
  { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
  { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
  { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
  { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
  { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
  { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
  { name: "HbA1c Test", cat: "Lab Test" },
  { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
  { name: "Bleeding Time (BT)", cat: "Lab Test" },
  { name: "Clotting Time (CT)", cat: "Lab Test" },
  { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
  { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
  { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
  { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
  { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
  { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
  {
    name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
    cat: "Antibiotic",
  },
  { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
  { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
  { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
  { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
  { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
  { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
  { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
  { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
  { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
  { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
  { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
  { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
  { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
  { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
];

// ✅ saveCustomMed — calls api.post directly (no detached prop)
function saveCustomMed(name) {
  if (!name || name.trim().length < 2) return Promise.resolve(null);
  if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
  const nameLow = name.trim().toLowerCase();
  const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
  if (already) return Promise.resolve(null);
  return fetch(
    (process.env.REACT_APP_API_URL || "http://localhost:5000/api") +
      "/custommeds",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(localStorage.getItem("pearlsmile_token")
          ? {
              Authorization:
                "Bearer " + localStorage.getItem("pearlsmile_token"),
            }
          : {}),
      },
      body: JSON.stringify({ name: name.trim(), cat: "Custom" }),
    },
  )
    .then((r) => (r.ok ? r.json() : null))
    .catch((err) => {
      console.warn("Custom med save failed:", err);
      return null;
    });
}

function googleSearch(query, customMeds = []) {
  const words = query
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter((w) => w.length > 0);
  if (!words.length) return [];
  const safeMeds = Array.isArray(customMeds)
    ? customMeds.filter(
        (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
      )
    : [];
  const combined = [
    ...MEDICINE_DB,
    ...safeMeds.map((m) => ({ ...m, _custom: true })),
  ];
  const scored = combined
    .map((m) => {
      if (!m || typeof m.name !== "string") return { m, score: 0 };
      const nameLow = m.name.toLowerCase(),
        catLow = (m.cat || "").toLowerCase();
      let score = 0;
      for (const w of words) {
        if (nameLow.startsWith(w)) score += 5;
        else if (nameLow.includes(w)) score += 3;
        else if (catLow.includes(w)) score += 1;
      }
      if (m._custom) score += 2;
      return { m, score };
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((x) => x.m);
  return scored.slice(0, 12);
}

function highlightWords(text, query) {
  const words = query
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter((w) => w.length > 0);
  let result = text;
  words.forEach((w) => {
    const re = new RegExp(
      "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
      "gi",
    );
    result = result.replace(re, "<b>$1</b>");
  });
  return result;
}

// ── RxMedInput — async 250k API + local search, portal dropdown ──
function RxMedInput({ value, onChange, customMeds = [], onCustomSaved }) {
  const inpRef = React.useRef(null),
    wrapRef = React.useRef(null);
  const [sugs, setSugs] = React.useState([]);
  const [activeIdx, setActive] = React.useState(-1);
  const [query, setQuery] = React.useState("");
  const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });
  const hide = () => {
    setSugs([]);
    setActive(-1);
    setQuery("");
  };

  const handleChange = async (e) => {
    const v = e.target.value;
    onChange(v);
    if (v.trim().length < 2) {
      hide();
      return;
    }
    const localMatches = googleSearch(v, customMeds);
    const apiMatches = await searchMedicinesAPI(v);
    const localNames = new Set(localMatches.map((m) => m.name.toLowerCase()));
    const merged = [
      ...localMatches,
      ...apiMatches.filter((m) => !localNames.has(m.name.toLowerCase())),
    ].slice(0, 12);
    if (!merged.length) {
      hide();
      return;
    }
    setQuery(v);
    setSugs(merged);
    setActive(-1);
    requestAnimationFrame(() => {
      if (!inpRef.current) return;
      const r = inpRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - r.bottom;
      const dropH = Math.min(220, merged.length * 36);
      const top =
        spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
      setDropPos({ top, left: r.left, width: r.width });
    });
  };

  const handleKeyDown = (e) => {
    if (!sugs.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActive((i) => Math.min(i + 1, sugs.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActive((i) => Math.max(i - 1, 0));
    } else if (
      (e.key === "Enter" || e.key === "Tab") &&
      activeIdx >= 0 &&
      sugs[activeIdx]
    ) {
      e.preventDefault();
      select(sugs[activeIdx].name);
    } else if (e.key === "Escape") hide();
  };

  const select = (name) => {
    onChange(name);
    hide();
    saveCustomMed(name).then((saved) => {
      if (onCustomSaved) onCustomSaved(saved || null);
    });
    setTimeout(() => {
      if (inpRef.current) inpRef.current.focus();
    }, 0);
  };

  React.useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
    };
    document.addEventListener("mousedown", handler);
    const scrollHandler = () => {
      if (sugs.length > 0 && inpRef.current) {
        const r = inpRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - r.bottom;
        const dropH = Math.min(220, sugs.length * 36);
        const top =
          spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
        setDropPos({ top, left: r.left, width: r.width });
      }
    };
    window.addEventListener("scroll", scrollHandler, true);
    return () => {
      document.removeEventListener("mousedown", handler);
      window.removeEventListener("scroll", scrollHandler, true);
    };
  }, [sugs.length]);

  return (
    <div ref={wrapRef} style={{ position: "relative" }}>
      <input
        ref={inpRef}
        type="text"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="Type medicine name..."
        autoComplete="off"
        style={{
          width: "100%",
          border: "1px solid #ddd",
          borderRadius: 5,
          padding: "5px 8px",
          fontSize: 12,
          fontFamily: "'DM Sans',sans-serif",
        }}
      />
      {sugs.length > 0 && (
        <div
          style={{
            position: "fixed",
            top: dropPos.top,
            left: dropPos.left,
            width: Math.max(dropPos.width, 280),
            background: "#fff",
            border: "1.5px solid #0d7377",
            borderRadius: 8,
            boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
            zIndex: 999999,
            maxHeight: 220,
            overflowY: "auto",
            fontFamily: "'DM Sans',sans-serif",
          }}
        >
          {sugs.map((m, i) => (
            <div
              key={m.name + i}
              style={{
                padding: "7px 12px",
                cursor: "pointer",
                fontSize: 12,
                background: i === activeIdx ? "#e8f7f7" : "#fff",
                borderBottom: "1px solid #f0eeeb",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
              onMouseDown={(e) => {
                e.preventDefault();
                select(m.name);
              }}
              onMouseEnter={() => setActive(i)}
            >
              <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
                💊
              </span>
              <span
                style={{ flex: 1, fontWeight: 500 }}
                dangerouslySetInnerHTML={{
                  __html: highlightWords(m.name, query),
                }}
              />
              <span
                style={{
                  fontSize: 10,
                  color: "#9a9590",
                  background: "#f0eeeb",
                  padding: "1px 6px",
                  borderRadius: 20,
                  flexShrink: 0,
                }}
              >
                {m.cat}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── MedAutocomplete — Doctor Notes textarea ───────────────────
function MedAutocomplete({
  value,
  onChange,
  customMeds = [],
  onCustomSaved,
  apiPost,
}) {
  const taRef = React.useRef(null),
    wrapperRef = React.useRef(null);
  const [suggestions, setSuggestions] = React.useState([]);
  const [activeIdx, setActiveIdx] = React.useState(-1);
  const [currentQuery, setCurrentQuery] = React.useState("");
  const queryStartRef = React.useRef(0),
    queryEndRef = React.useRef(0);
  const hideSuggestions = () => {
    setSuggestions([]);
    setActiveIdx(-1);
    setCurrentQuery("");
  };
  const handleChange = (e) => {
    const ta = e.target,
      val = ta.value,
      cursor = ta.selectionStart;
    onChange(val);
    let lineStart = cursor - 1;
    while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
    lineStart++;
    const query = val.substring(lineStart, cursor);
    queryStartRef.current = lineStart;
    queryEndRef.current = cursor;
    if (query.trim().length < 2) {
      hideSuggestions();
      return;
    }
    const matches = googleSearch(query, customMeds);
    if (!matches.length) {
      hideSuggestions();
      return;
    }
    setCurrentQuery(query);
    setSuggestions(matches);
    setActiveIdx(-1);
  };
  const handleKeyDown = (e) => {
    if (!suggestions.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIdx((i) => Math.max(i - 1, 0));
    } else if (
      (e.key === "Enter" || e.key === "Tab") &&
      activeIdx >= 0 &&
      suggestions[activeIdx]
    ) {
      e.preventDefault();
      selectMed(suggestions[activeIdx].name);
    } else if (e.key === "Escape") hideSuggestions();
  };
  const selectMed = (name) => {
    const ta = taRef.current,
      val = ta.value;
    const before = val.substring(0, queryStartRef.current),
      after = val.substring(queryEndRef.current);
    onChange(before + name + after);
    hideSuggestions();
    saveCustomMed(name).then((saved) => {
      if (onCustomSaved) onCustomSaved(saved || null);
    });
    setTimeout(() => {
      if (taRef.current) {
        const nc = queryStartRef.current + name.length;
        taRef.current.setSelectionRange(nc, nc);
        taRef.current.focus();
        queryEndRef.current = nc;
      }
    }, 0);
  };
  const handleBlur = () => {
    if (!taRef.current) return;
    taRef.current.value.split("\n").forEach((line) => {
      const trimmed = line.trim();
      if (
        trimmed.length >= 3 &&
        /[a-zA-Z]/.test(trimmed) &&
        !/^[0-9\s]+$/.test(trimmed)
      ) {
        saveCustomMed(trimmed).then((saved) => {
          if (saved && onCustomSaved) onCustomSaved(saved);
        });
      }
    });
  };
  React.useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target))
        hideSuggestions();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <>
      <style>{`.med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}.med-suggestion-item:last-child{border-bottom:none;}.med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}.med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}.med-sug-name{font-weight:500;flex:1;color:#1a1614;}.med-sug-name b{color:#0d7377;font-weight:700;}.med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}`}</style>
      <div style={{ position: "relative" }} ref={wrapperRef}>
        <textarea
          ref={taRef}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          autoComplete="off"
          placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
        />
        {suggestions.length > 0 && (
          <div
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1.5px solid #0d7377",
              borderTop: "none",
              borderRadius: "0 0 12px 12px",
              boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
              zIndex: 99999,
              maxHeight: 280,
              overflowY: "auto",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            {suggestions.map((m, i) => (
              <div
                key={m.name + i}
                className={
                  "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
                }
                onMouseDown={(e) => {
                  e.preventDefault();
                  selectMed(m.name);
                }}
              >
                <span className="med-sug-icon">💊</span>
                <span
                  className="med-sug-name"
                  dangerouslySetInnerHTML={{
                    __html: highlightWords(m.name, currentQuery),
                  }}
                />
                <span className="med-sug-cat">{m.cat}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

// ── Prescription Modal — exact original from document 3 ───────
function PrescriptionModal({
  visit,
  patient,
  doctor,
  hospital,
  onClose,
  showNotify,
}) {
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [rxMobile, setRxMobile] = useState("");
  const [fileName, setFileName] = useState("");
  const [canNativeShare, setCanNativeShare] = useState(false);

  const hospitalName = hospital?.name || "PearlSmile Dental Hospital";
  const hospitalAddress = hospital?.address || "12, Dental Plaza, MG Road";
  const hospitalCity = hospital?.city || "Pune - 411001";
  const hospitalPhone = hospital?.phone || "+91 87936 08083";
  const hospitalEmail = hospital?.email || "care@pearlsmiledental.in";
  const hospitalTagline = hospital?.tagline || "Dental Hospital";
  const stampText = hospitalName.toUpperCase().split(" ").slice(0, 2).join(" ");
  const headerLine1 = hospitalName.toUpperCase().split(" ")[0];
  const headerLine2 =
    hospitalName.toUpperCase().split(" ").slice(1).join(" ") ||
    hospitalTagline.toUpperCase();

  useEffect(() => {
    generatePDF();
  }, []);
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  const fmtDateLocal = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr + "T00:00:00");
    return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
  };
  const fmtTimeLocal = (t) => {
    if (!t) return "";
    const parts = t.split(":");
    const hh = parseInt(parts[0]),
      mm = parts[1];
    return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
  };

  const generatePDF = () => {
    if (window.jspdf) {
      buildPDF();
      return;
    }
    const existing = document.getElementById("jspdf-cdn");
    if (existing) {
      existing.addEventListener("load", buildPDF);
      return;
    }
    const script = document.createElement("script");
    script.id = "jspdf-cdn";
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    script.crossOrigin = "anonymous";
    script.onload = buildPDF;
    script.onerror = () => setLoading(false);
    document.head.appendChild(script);
  };

  const buildPDF = () => {
    const { jsPDF } = window.jspdf;
    const pdf = new jsPDF({
      unit: "mm",
      format: "a4",
      orientation: "portrait",
    });
    const W = 210,
      H = 297;
    const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
    const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
    const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
    const NAVY = [8, 25, 65],
      BLUE = [20, 80, 160],
      LBLUE = [210, 228, 248],
      LBLUE2 = [232, 242, 252],
      MIDBLUE = [160, 195, 235];
    const TEAL = [0, 130, 130],
      TEAL2 = [210, 240, 240],
      WHITE = [255, 255, 255],
      LGRAY = [245, 247, 251],
      LGRAY2 = [250, 251, 254];
    const LGRAY3 = [240, 243, 248],
      GRAY = [115, 118, 130],
      GRAY2 = [75, 80, 95],
      GOLD = [170, 130, 40],
      GOLD2 = [250, 245, 225];
    const INK = [28, 52, 140],
      INK2 = [45, 75, 170];
    const today = new Date();
    const todayFmt =
      today.getDate() +
      " " +
      MONTHS[today.getMonth()] +
      " " +
      today.getFullYear();
    const rxNum =
      "PS-" +
      today.getFullYear() +
      ("0" + (today.getMonth() + 1)).slice(-2) +
      ("0" + today.getDate()).slice(-2) +
      "-" +
      Math.floor(1000 + Math.random() * 8999);
    const visitDate = visit.visitDate || "",
      visitTime = visit.visitTime || "",
      notes = visit.notes || "",
      nextDate = visit.nextVisitDate || "",
      service = visit.service || "";
    const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
    const visitDateFmt = fmtDateLocal(visitDate),
      visitTimeFmt = fmtTimeLocal(visitTime),
      nextDateFmt = fmtDateLocal(nextDate);
    sd(MIDBLUE);
    pdf.setLineWidth(0.8);
    pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
    sd(LBLUE);
    pdf.setLineWidth(0.3);
    pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
    sf(NAVY);
    pdf.rect(3.5, 3.5, W - 7, 46, "F");
    sf(BLUE);
    pdf.rect(3.5, 43, W - 7, 10, "F");
    sf(LBLUE);
    pdf.rect(3.5, 53, W - 7, 6, "F");
    st(WHITE);
    pdf.setFontSize(18);
    pdf.setFont("helvetica", "bold");
    pdf.text(doc.name, 14, 19);
    st(LBLUE);
    pdf.setFontSize(8);
    pdf.setFont("helvetica", "normal");
    pdf.text((doc.qual || "").toUpperCase(), 14, 26);
    sd(MIDBLUE);
    pdf.setLineWidth(0.25);
    pdf.line(14, 28.5, W - 40, 28.5);
    st(LGRAY);
    pdf.setFontSize(7);
    pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
    pdf.text("Specialisation:  Health Care", 14, 38.5);
    st(WHITE);
    pdf.setFontSize(15);
    pdf.setFont("helvetica", "bold");
    pdf.text(headerLine1, W - 10, 19, { align: "right" });
    st(LBLUE);
    pdf.setFontSize(7.5);
    pdf.setFont("helvetica", "normal");
    pdf.text(headerLine2, W - 10, 25.5, { align: "right" });
    sd(MIDBLUE);
    pdf.setLineWidth(0.25);
    pdf.line(W - 72, 28.5, W - 10, 28.5);
    st(LGRAY);
    pdf.setFontSize(6.8);
    pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, 33.5, {
      align: "right",
    });
    pdf.text(hospitalPhone + "  |  " + hospitalEmail, W - 10, 38.5, {
      align: "right",
    });
    st(WHITE);
    pdf.setFontSize(9);
    pdf.setFont("helvetica", "bold");
    pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
    st(LBLUE2);
    pdf.setFontSize(7);
    pdf.setFont("helvetica", "normal");
    pdf.text("Rx No.: " + rxNum, 10, 50);
    pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
    st(BLUE);
    pdf.setFontSize(7.5);
    pdf.setFont("helvetica", "bold");
    pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
    const infoTop = 61;
    sf(LGRAY3);
    pdf.rect(10, infoTop, W - 20, 44, "F");
    sd(LBLUE);
    pdf.setLineWidth(0.25);
    pdf.rect(10, infoTop, W - 20, 44, "S");
    sd(MIDBLUE);
    pdf.setLineWidth(0.2);
    pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
    let rdy = infoTop + 11;
    for (let ri = 0; ri < 3; ri++) {
      pdf.line(10, rdy, W - 10, rdy);
      rdy += 11;
    }
    const drawCell = (label, value, x, y, maxW) => {
      st(GRAY2);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(6.8);
      pdf.text(label, x + 3, y + 4);
      st(NAVY);
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(8.5);
      const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
      pdf.text(val[0], x + 3, y + 9.5);
    };
    const cHalf = W / 2;
    drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
    drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
    drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
    drawCell(
      "BLOOD GROUP",
      patient.blood || "—",
      cHalf,
      infoTop + 11,
      cHalf - 16,
    );
    drawCell(
      "AGE / GENDER",
      (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
      10,
      infoTop + 22,
      cHalf - 16,
    );
    drawCell(
      "VISIT DATE",
      visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
      cHalf,
      infoTop + 22,
      cHalf - 16,
    );
    drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
    drawCell(
      "NEXT VISIT DATE",
      nextDateFmt || "—",
      cHalf,
      infoTop + 33,
      cHalf - 16,
    );
    const diagTop = infoTop + 50;
    const rxRows =
      visit.prescription && visit.prescription.medicineRows
        ? visit.prescription.medicineRows.filter(
            (r) => r.medicine && r.medicine.trim(),
          )
        : [];
    let rxTableEndY = diagTop;
    if (rxRows.length > 0) {
      const tTop = diagTop;
      sf(BLUE);
      pdf.rect(10, tTop, W - 20, 7, "F");
      st(WHITE);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(7.5);
      pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
      const colX = [10, 20, 90, 155, 183];
      let ry = tTop + 7;
      sf(LGRAY3);
      pdf.rect(10, ry, W - 20, 6, "F");
      [
        ["SR.", "normal", 6],
        ["MEDICINE", "bold", 6],
        ["DOSAGE INSTRUCTION", "normal", 6],
        ["DURATION", "normal", 6],
        ["ROUTE", "normal", 6],
      ].forEach(([h, fw, fs], hi) => {
        st(GRAY2);
        pdf.setFont("helvetica", fw);
        pdf.setFontSize(fs);
        pdf.text(h, colX[hi] + 1, ry + 4.5);
      });
      ry += 6;
      rxRows.forEach((row, ri) => {
        sf(ri % 2 === 0 ? LGRAY2 : WHITE);
        pdf.rect(10, ry, W - 20, 7, "F");
        sd(LBLUE);
        pdf.setLineWidth(0.1);
        pdf.rect(10, ry, W - 20, 7, "S");
        st(GRAY2);
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(6);
        pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
        st(NAVY);
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(7);
        pdf.text(
          pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
          colX[1] + 1,
          ry + 4.5,
        );
        st(GRAY2);
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(6.5);
        pdf.text(
          pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
          colX[2] + 1,
          ry + 4.5,
        );
        pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
        pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
        ry += 7;
      });
      rxTableEndY = ry + 4;
    }
    const notesTop = rxTableEndY + 4;
    sf(BLUE);
    pdf.rect(10, notesTop, W - 20, 8, "F");
    st(WHITE);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(8.5);
    pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
    st(GOLD);
    pdf.setFontSize(10);
    pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
    // ✅ FIX: Dynamic notesBoxH — adapts to available space so stamp never overflows
    const SIG_ZONE_START = H - 62; // stamp + footer need 62mm at bottom
    const hasNext = !!nextDateFmt;
    const reservedBelow = 8 + (hasNext ? 19 : 0) + 4 + 20 + 4; // tableGap + nextDate + gap + advBox + gap
    const maxNotesBoxH = Math.max(
      12,
      SIG_ZONE_START - notesTop - 8 - reservedBelow,
    );
    const notesBoxH = Math.min(46, maxNotesBoxH);
    sf(LGRAY2);
    pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
    sd(LBLUE);
    pdf.setLineWidth(0.25);
    pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
    sd([215, 225, 240]);
    pdf.setLineWidth(0.15);
    for (let rl = 0; rl < 6; rl++)
      pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
    st(NAVY);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9.5);
    const noteLines = pdf.splitTextToSize(
      notes || "No diagnosis or notes recorded for this visit.",
      W - 30,
    );
    pdf.text(noteLines, 14, notesTop + 15);
    let tableEndY = notesTop + notesBoxH + 8,
      afterY = tableEndY;
    if (nextDateFmt) {
      sf(TEAL2);
      pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
      sd(TEAL);
      pdf.setLineWidth(0.4);
      pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
      sf(TEAL);
      pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
      st(WHITE);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(6.5);
      pdf.text("NEXT", 11.2, afterY + 5.5);
      pdf.text("VISIT", 11.0, afterY + 10);
      st(TEAL);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(9);
      pdf.text("Next Appointment:", 24, afterY + 6.5);
      st(NAVY);
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "bold");
      pdf.text(nextDateFmt, 72, afterY + 6.5);
      st(GRAY);
      pdf.setFontSize(7);
      pdf.setFont("helvetica", "italic");
      pdf.text(
        "Please arrive 10 minutes early and bring this prescription.",
        24,
        afterY + 11,
      );
      afterY += 19;
    }
    const advY = afterY + 4;
    sf(GOLD2);
    pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
    sd(GOLD);
    pdf.setLineWidth(0.35);
    pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
    sf(GOLD);
    pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
    st(WHITE);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(6.2);
    pdf.text("GEN.", 11.2, advY + 8);
    pdf.text("ADV.", 11.2, advY + 13.5);
    st(GOLD);
    pdf.setFontSize(7.5);
    pdf.setFont("helvetica", "bold");
    pdf.text("General Advice:", 24, advY + 6.5);
    st(GRAY2);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    pdf.text(
      "1.  Follow all prescribed medicines on time and complete the full course.",
      24,
      advY + 11.5,
    );
    pdf.text(
      "2.  Maintain good oral hygiene. Brush gently twice daily.",
      24,
      advY + 15.5,
    );
    pdf.text(
      "3.  Avoid very hot, cold, or hard foods until fully healed.",
      24,
      advY + 19.2,
    );
    pdf.saveGraphicsState();
    pdf.setGState(new pdf.GState({ opacity: 0.035 }));
    st(NAVY);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(44);
    pdf.text(headerLine1, W / 2, H / 2 - 5, { align: "center", angle: 35 });
    pdf.restoreGraphicsState();
    // ✅ FIX: Stamp at FIXED absolute position — never overflows footer
    const cx = W - 46,
      cy = H - 47,
      R = 18,
      sigY = cy - 13;
    sd(INK);
    pdf.setLineWidth(1.2);
    pdf.circle(cx, cy, R, "S");
    pdf.setLineWidth(0.4);
    pdf.circle(cx, cy, R - 2.5, "S");
    const drawStar = (sx, sy, sr) => {
      const pts = [];
      for (let si = 0; si < 5; si++) {
        const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
          ai = ao + (2 * Math.PI) / 5;
        pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
        pts.push({
          x: sx + sr * 0.4 * Math.cos(ai),
          y: sy + sr * 0.4 * Math.sin(ai),
        });
      }
      pdf.setLineWidth(0.3);
      sd(INK);
      sf(INK);
      pdf.lines(
        pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
        pts[0].x,
        pts[0].y,
        [1, 1],
        "FD",
        true,
      );
    };
    drawStar(cx - R + 3.5, cy + 1, 2.2);
    drawStar(cx + R - 3.5, cy + 1, 2.2);
    const docShort = (doc.name || "Doctor").toUpperCase();
    sd(INK);
    st(INK);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(5.8);
    const topSpan = Math.min(docShort.length * 0.19, 1.3),
      topStart = -Math.PI / 2 - topSpan / 2;
    for (let ti = 0; ti < docShort.length; ti++) {
      const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
      const tx = cx + (R - 1.5) * Math.cos(ta),
        ty = cy + (R - 1.5) * Math.sin(ta);
      const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
      pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
    }
    pdf.setFontSize(5.5);
    const botStr = stampText,
      botSpan = Math.min(botStr.length * 0.175, 1.4),
      botStart = Math.PI / 2 - botSpan / 2;
    for (let bi = 0; bi < botStr.length; bi++) {
      const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
      const bx = cx + (R - 1.5) * Math.cos(ba),
        by = cy + (R - 1.5) * Math.sin(ba);
      const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
      pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
    }
    // ✅ FIX: Complete stamp center — vertical staff + horizontal crossbar + Rx symbol
    sd(INK);
    pdf.setLineWidth(0.8);
    pdf.line(cx, cy - 9, cx, cy + 8);
    // Horizontal crossbar (makes proper cross)
    pdf.setLineWidth(0.6);
    pdf.line(cx - 5, cy - 3, cx + 5, cy - 3);
    // Top decorative wings
    pdf.setLineWidth(0.5);
    pdf.line(cx, cy - 8.5, cx - 4, cy - 10.5);
    pdf.line(cx - 4, cy - 10.5, cx - 6, cy - 9);
    pdf.line(cx - 6, cy - 9, cx - 3, cy - 7.5);
    pdf.line(cx, cy - 8.5, cx + 4, cy - 10.5);
    pdf.line(cx + 4, cy - 10.5, cx + 6, cy - 9);
    pdf.line(cx + 6, cy - 9, cx + 3, cy - 7.5);
    sf(INK);
    pdf.circle(cx, cy - 9.2, 1, "F");
    // Small horizontal lines on staff
    pdf.setLineWidth(0.4);
    pdf.line(cx - 3, cy + 1, cx + 3, cy + 1);
    pdf.line(cx - 2, cy + 4, cx + 2, cy + 4);
    // Center "Rx" text in stamp middle
    st(INK);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(7);
    pdf.text("Rx", cx, cy - 0.5, { align: "center" });
    st(INK);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(4.5);
    pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
    st(INK2);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(6.5);
    pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
    st(GRAY);
    pdf.setFontSize(7);
    pdf.setFont("helvetica", "normal");
    pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
    pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
    sf(NAVY);
    pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
    sf(BLUE);
    pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
    st(WHITE);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(7.5);
    pdf.text(hospitalName, 10, H - 14.5);
    st(LBLUE);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    pdf.text(hospitalPhone, 10, H - 9.5);
    pdf.text(hospitalEmail, W / 2, H - 9.5, { align: "center" });
    pdf.text(hospitalAddress + ", " + hospitalCity, W - 10, H - 9.5, {
      align: "right",
    });
    st(LBLUE2);
    pdf.setFontSize(6);
    pdf.setFont("helvetica", "italic");
    pdf.text(
      "This is a computer-generated prescription from " +
        hospitalName +
        ". Valid only with authorised doctor details.",
      W / 2,
      H - 5.5,
      { align: "center" },
    );
    const blob = pdf.output("blob");
    const url = URL.createObjectURL(blob);
    const name =
      "Prescription_" +
      (patient.name || "Patient").replace(/\s+/g, "_") +
      "_" +
      visitDate +
      ".pdf";
    let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
    if (!rawMob.startsWith("91") && rawMob.length === 10)
      rawMob = "91" + rawMob;
    setPdfBlob(blob);
    setPdfUrl(url);
    setRxMobile(rawMob);
    setFileName(name);
    const testFile = new File([blob], name, { type: "application/pdf" });
    if (
      navigator.share &&
      navigator.canShare &&
      navigator.canShare({ files: [testFile] })
    )
      setCanNativeShare(true);
    setLoading(false);
  };

  const openFullPreview = () => {
    if (pdfUrl) window.open(pdfUrl, "_blank");
  };
  const shareViaWhatsApp = async () => {
    if (!pdfBlob) return;
    const file = new File([pdfBlob], fileName, { type: "application/pdf" });
    if (
      navigator.share &&
      navigator.canShare &&
      navigator.canShare({ files: [file] })
    ) {
      navigator
        .share({
          title: "Digital Prescription — " + hospitalName,
          text: "Dear Patient, please find your digital prescription.",
          files: [file],
        })
        .then(() => {
          showNotify("Sent! ✓", "Prescription shared successfully.");
          onClose();
        })
        .catch((err) => {
          if (err.name !== "AbortError" && rxMobile) {
            const waMsg = encodeURIComponent(
              "Dear Patient, your digital prescription is ready. Please contact us to receive the PDF.",
            );
            window.open(
              "https://wa.me/" + rxMobile + "?text=" + waMsg,
              "_blank",
            );
          }
        });
    } else {
      if (rxMobile) {
        const waMsg = encodeURIComponent(
          "Dear Patient, your digital prescription is ready.",
        );
        window.open("https://wa.me/" + rxMobile + "?text=" + waMsg, "_blank");
        showNotify(
          "WhatsApp Opened! ✓",
          "Send the message to notify the patient.",
        );
      } else {
        showNotify(
          "No mobile number",
          "Please add patient's mobile number first.",
          true,
        );
      }
    }
  };
  const downloadPDF = () => {
    if (!pdfBlob) return;
    const dlLink = document.createElement("a");
    dlLink.href = pdfUrl;
    dlLink.download = fileName;
    dlLink.click();
    showNotify(
      "Downloaded ✓",
      "Prescription PDF saved to your Downloads folder.",
    );
  };

  return (
    <div
      className="rx-share-overlay open"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 20,
          width: "100%",
          maxWidth: 540,
          boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          maxHeight: "92vh",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
            padding: "18px 22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 22 }}>📄</span>
            <div>
              <div
                style={{
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 15,
                  fontFamily: "DM Sans,sans-serif",
                }}
              >
                Digital Prescription Ready
              </div>
              <div
                style={{
                  color: "rgba(255,255,255,0.55)",
                  fontSize: 12,
                  fontFamily: "DM Sans,sans-serif",
                }}
              >
                {patient.name} · {visit.visitDate}
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "rgba(255,255,255,0.12)",
              border: "none",
              color: "#fff",
              width: 32,
              height: 32,
              borderRadius: "50%",
              fontSize: 17,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✕
          </button>
        </div>
        <div
          style={{
            flex: 1,
            overflow: "hidden",
            background: "#f0eeeb",
            minHeight: 340,
            position: "relative",
          }}
        >
          {loading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "#f0eeeb",
                gap: 10,
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  border: "3px solid #0d7377",
                  borderTopColor: "transparent",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                }}
              />
              <div
                style={{
                  fontSize: 13,
                  color: "#5a5550",
                  fontFamily: "DM Sans,sans-serif",
                }}
              >
                Generating PDF…
              </div>
            </div>
          )}
          {pdfUrl && (
            <iframe
              title="prescription"
              src={pdfUrl}
              style={{ width: "100%", height: 420, border: "none" }}
            />
          )}
        </div>
        <div
          style={{
            padding: "16px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 10,
            background: "#fff",
          }}
        >
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={openFullPreview}
              style={{
                flex: 1,
                background: "#f0eeeb",
                color: "#0a1628",
                border: "1.5px solid #ddd9d3",
                borderRadius: 10,
                padding: 10,
                fontSize: 13,
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: "DM Sans,sans-serif",
                transition: "background 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "#e5e0d8")
              }
              onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
            >
              🔍 Open Full PDF
            </button>
            <button
              onClick={downloadPDF}
              style={{
                flex: 1,
                background: "#f0eeeb",
                color: "#0a1628",
                border: "1.5px solid #ddd9d3",
                borderRadius: 10,
                padding: 10,
                fontSize: 13,
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: "DM Sans,sans-serif",
                transition: "background 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "#e5e0d8")
              }
              onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
            >
              ⬇️ Download PDF
            </button>
          </div>
          <button
            onClick={shareViaWhatsApp}
            style={{
              width: "100%",
              background: "linear-gradient(135deg,#25d366,#128c7e)",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "11px",
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "DM Sans,sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
            </svg>
            Send via WhatsApp
          </button>
          <p
            style={{
              fontSize: 11,
              color: "#9a9590",
              textAlign: "center",
              margin: 0,
              fontFamily: "DM Sans,sans-serif",
              lineHeight: 1.5,
            }}
          >
            On mobile: tap "Send via WhatsApp" to share directly.
            <br />
            On desktop: use "Open Full PDF" to view, or "Download PDF" to save.
          </p>
        </div>
      </div>
    </div>
  );
}
